import { Button, ButtonGroup, Grid, Menu, MenuItem, MenuList, Paper, Tooltip } from '@material-ui/core'
import Color from 'color'
import Autocomplete from 'Components/AutoComplete'
import DatePicker from 'Components/DatePicker'
import EmojiEuresto from 'Components/Emoji'
import EurestoTable from 'Components/EurestoTable'
import Input from 'Components/Input'
import ListingModal from 'Components/ListingModal'
import Modal from 'Components/Modal'
import NavLink from 'Components/NavLink'
import PhoneInput from 'Components/PhoneInput'
import Select from 'Components/Select'
import Title from 'Components/Title'
import Wysiwyg from 'Components/Wysiwyg'
import { Emoji } from 'emoji-mart'
import ApiRequest from 'EurestoApi/ApiRequest'
import Data from 'EurestoClass/Data'
import User from 'EurestoClass/User'
import ApercuImage from 'EurestoComponents/ApercuImage'
import DataComponent from 'EurestoComponents/DataComponents/index'
import EurestoDiv from 'EurestoComponents/EurestoDiv/index'
import DefaultUpload from 'EurestoComponents/Upload/DefaultUpload'
import project from 'EurestoConfig/project.config'
import Constants from 'EurestoFonction/Constants'
import Utils from 'EurestoFonction/Utils'
import avatarPersonne from 'EurestoStyle/font/avatarPersonne.png'
import h2p from 'html2plaintext'
import moment from 'moment'
import React from 'react'
import { browserHistory } from 'react-router'
import SplitPane from 'react-split-pane'
import { WebSocketContact } from '../../../../../Utilitaire/Websocket/index'
import Relation from '../../../CRM/Component/Relation'
import DataGrid from '../../../CRM/Component/Table'
import LineBreakText from '../../Component/LineBreakText'
import DataGridCas from '../../Page/Cas'









moment.locale('fr')

export default class extends React.Component {
    autoScroll = false

    constructor(props) {
        super(props)

        const regroupement = Data.list(Constants.module.CONFIGURATION, Constants.donnee.groupe_utilisateur)
        const utilisateurs = Data.list(Constants.module.CONFIGURATION, Constants.donnee.utilisateur, {
            civilite_id: {
                not: true,
                value: null
            }
        })

        let options = []
        regroupement.map(grp => {
            options.push({
                label: grp.libelle,
                value: grp.id,
                html: <strong>{grp.libelle}</strong>,
                archive_id: !grp.actif
            })

            if (grp.actif) {
            options = options.concat((grp.utilisateurs || []).map(uid => ({
                label: (utilisateurs.find(u => u.id === uid) || {}).slibelle,
                html: <span style={{ paddingLeft: 5 }}>{(utilisateurs.find(u => u.id === uid) || {}).slibelle}</span>,
                value: uid,
                archive_id: (utilisateurs.find(u => u.id === uid) || {}).archive_id,
                groupe_id: grp.id,
                portable: '',
                email: grp.email
            })))
            }
        })
        if ((utilisateurs || []).length > 0) {
            options.push({
                label: 'Utilisateurs',
                html: <Grid container onClick={e => e.stopPropagation()}
                    style={{ cursor: 'not-allowed', width: '100%', margin: 0, padding: 0 }} justify={'center'}
                    alignItems={'center'}><strong>Utilisateurs</strong></Grid>,
                value: undefined
            })
        }
        utilisateurs.map(user => {
            options.push({
                label: user.slibelle,
                value: user.id,
                archive_id: user.archive_id,
                portable: user.portable,
                email: user.email
            })
        })

        this.state = {
            cas: {},
            actionFlagsSelected: {},
            preSelectedAction: props.preSelectedAction,
            actions_user: [],
            client_id: this.props.client_id,
            uploadFileAction: [],
            anchorActionEl: {},
            anchorFlagActionEl: {},
            anchorDateInterventionActionEl: {},
            anchorUserAssignActionEl: {},
            messageConfiguration: [],
            dossier: {},
            classeurExpended: {},
            dossiers: [],
            dossierId: undefined,
            actions: [],
            dossierKey: Utils.getRandomNumber(),
            type_action_id: Constants.typeAction.Message,
            reponse_to_action_id: undefined,
            newEmail: {},
            GroupeUtilisateurOptions: options,
            keyUpload: Utils.getRandomNumber(),
            keyWysiwyg: Utils.getRandomNumber(),
            keySource: Utils.getRandomNumber(),
            showOnlyOpenTicket: !User.User.get().visu_ticket_ferme,
        }
    }

    async componentDidMount() {
        if (this.props.client_id !== undefined) {
            this.searchClient(this.props.client_id, 'client_id')
        }
    }

    scrollToAction = true

    componentDidUpdate(prevProps, prevState) {
        if (this.autoScroll && !(this.state.preSelectedAction && this.scrollToAction)) {
            this.scrollToBottom()
            this.autoScroll = !this.messageEnd
        }
        if (this.state.preSelectedAction && this.scrollToAction) {
            this.actionEl && this.actionEl.scrollIntoView({ behavior: 'smooth' })
            this.scrollToAction = !this.actionEl
            this.autoScroll = !this.actionEl
        }
    }

    dossierOuvert = _ => {
        return (this.state.dossiers || []).find(d => parseInt(d.id) === this.state.dossierId) && (this.state.dossiers || []).find(d => parseInt(d.id) === this.state.dossierId).status === 1 || (this.state.dossiers || []).find(d => parseInt(d.id) === this.state.dossierId) === undefined
    }

    getActionContact = async (id, search = {}) => {
        const result = await ApiRequest(project.api + 'sdd', {
            action: 'list',
            requete: 'action',
            contact_id: id,
            ...search
        }, { showAlertError: false })
        return result && result.results || []
    }

    getDossierContact = async (id) => {
        const result = await ApiRequest(project.api + 'sdd', {
            action: 'list',
            requete: 'dossier',
            group_by: ['sdd_action.contact_id',
                'sdd_action.classeur_id',
                'sdd_action.dossier_id'
            ],
            recherche: [{
                champ: 'contact_id',
                valeur: id,
                operation: 'egal'
            },
                ...(id !== 1 && [{
                champ: 'sdd_classeur.visible',
                valeur: 1,
                operation: 'egal'
            }] || [])
            ],
        }, { showAlertError: false })
        if (result) {
            return result.results
        } else {
            return []
        }
    }

    getDossierCas = async (id) => {
        const result = await ApiRequest(project.api + 'sdd', {
            action: 'list',
            requete: 'dossier',
            group_by: [
                'sdd_action.contact_id',
                'sdd_action.classeur_id',
                'sdd_action.dossier_id'
            ],
            recherche: [{
                champ: 'sdd_dossier_parent.id',
                valeur: id,
                operation: 'egal'
            },
            ],
        }, { showAlertError: false })
        if (result) {
            return result.results
        } else {
            return []
        }
    }

    getInfoContact = async (id) => {
        const result = await ApiRequest(project.api + 'crm', {
            action: 'get',
            requete: 'client',
            id: id
        }, { showAlertError: false })
        return result.results
    }

    searchClient = async (data, name) => {
        let dossiers = []
        let dossier = {}
        let relations = []
        let handleActionIndex = -1
        let handleDossierIndex = -1
        let classeurExpended = this.state.classeurExpended || {}
        let libelleClient = ''
        let actionsUser = []
        if (data) {
            dossiers = await this.getDossierContact(data)
            if (this.state.handleDossierIndex !== undefined) {
                User.ContactIdRegisterCallBack.reset({ dossier: this.state.handleDossierIndex })
            }
            handleDossierIndex = User.ContactIdRegisterCallBack.set({ dossier: this.handleNewDossier }).dossier

            const client = await this.getInfoContact(data)
            if (client.relations && client.relations.length > 0) {
                relations = client.relations
            }
            libelleClient = client.libelle
            if (this.state.handleActionIndex !== undefined) {
                User.ContactIdRegisterCallBack.reset({ action: this.state.handleActionIndex })
            }

            if (dossiers.length > 0) {
                let dossierIdLast
                let classeurIdLast
                if (this.props.preSelectedClasseur !== undefined && this.props.preSelectedClasseur !== null) {
                    dossierIdLast = this.props.preSelectedDossier
                    classeurIdLast = this.props.preSelectedClasseur
                } else {
                    const dossier = dossiers.find(d => this.state.showOnlyOpenTicket ? d.status !== 0 : true)
                    dossierIdLast = dossier && parseInt(dossier.dossier_id)
                    classeurIdLast = dossier && parseInt(dossier.classeur_id)
                }
                classeurExpended = this.expendClasseur(classeurIdLast, true)
                this.selectDossier(classeurIdLast, dossierIdLast)
            }

            actionsUser = await this.getActionContact(this.state.client_id, {
                recherche: [{
                    champ: 'user_assign_id',
                    valeur: User.User.get().id,
                    operation: 'egal',
                }, {
                    champ: 'etat',
                    valeur: 0,
                    operation: 'egal',
                }],
            }) || []

            handleActionIndex = User.ContactIdRegisterCallBack.set({ action: this.handleNewAction }).action
        }

        data === undefined || this.state.client_id !== data && WebSocketContact(data === undefined || this.state.client_id !== data, this.state.client_id)
        WebSocketContact(false, data)

        if (this.state.dossierId) {
            const dossier_id = this.state.dossierId && typeof this.state.dossierId === 'number' && this.state.dossierId || undefined
            const dossierSelect = EurestoClone(dossiers.find(d => parseInt(d.id) === dossier_id) || {})
            dossier.classeur_id = dossierSelect.classeur_id
            dossier.id = dossierSelect.id
            dossier.libelle = dossierSelect.libelle
            dossier.type_categorie_id = dossierSelect.type_categorie_id
            dossier.confidentiel = dossierSelect.confidentiel
            dossier.participants = dossierSelect.participants || []
            dossier.dossier_id = dossierSelect.dossier_parent_id
            dossier.dossier_parent_libelle = dossierSelect.dossier_parent_libelle || ''
            dossier.type_dossier = dossierSelect.type_dossier
        }

        this.setState({
            [name]: data,
            actions_user: actionsUser,
            relationExpended: false,
            dossier: dossier,
            dossiers: dossiers,
            handleActionIndex: handleActionIndex,
            handleDossierIndex: handleDossierIndex,
            relations: relations,
            classeurExpended: classeurExpended,
            libelle_client_contact: libelleClient
        })
    }

    selectDossier = async (classeur_id, dossier_id) => {
        dossier_id = dossier_id && parseInt(dossier_id)
        let newDossierId = dossier_id && parseInt(dossier_id) || 'default_' + classeur_id

        const actions = await this.getActionContact(this.state.client_id, {
            recherche: [{
                champ: 'dossier_id',
                operation: 'egal',
                valeur: dossier_id
            }, { champ: 'classeur_id', operation: 'egal', valeur: classeur_id }]
        }) || []

        let dossiers = []
        if (classeur_id === 49 || classeur_id === 50) {
            dossiers = await this.getDossierCas(dossier_id)
        }

        const dossier = {}
        const dossierSelect = EurestoClone(this.state.dossiers.find(d => parseInt(d.id) === dossier_id) || {})
        if (dossierSelect) {
            dossier.classeur_id = dossierSelect.classeur_id
            dossier.id = dossierSelect.id
            dossier.libelle = dossierSelect.libelle
            dossier.type_categorie_id = dossierSelect.type_categorie_id
            dossier.confidentiel = dossierSelect.confidentiel
            dossier.participants = dossierSelect.participants || []
            dossier.dossier_id = dossierSelect.dossier_parent_id
            dossier.dossier_parent_libelle = dossierSelect.dossier_parent_libelle || ''
            dossier.type_dossier = dossierSelect.type_dossier
        }

        this.autoScroll = true
        this.setState({
            action_id_update: undefined,
            date_echeance: undefined,
            dossierId: newDossierId,
            dossier: dossier,
            actions: actions,
            keyWysiwyg: Utils.getRandomNumber(),
            dossiersCas: dossiers
        })
    }

    recherche = (data, name) => {
        let messageToShow
        let libelle = this.state.libelle
        let keySource = this.state.keySource
        if (name === 'recherche_message_messagerie') {
            messageToShow = this.state.messages
        } else {
            messageToShow = this.state.messages
        }
        let source = this.state.source
        let portable_retour = this.state.portable_retour
        let email_retour = this.state.email_retour

        if (name === 'type_action_id' && (
            data === Constants.typeAction.SmsEnvoi
            || data === Constants.typeAction.EmailEnvoi
        )) {
            if (this.state.contact_relation_id) {
                const contactRelation = (this.state.relations || []).find(r => r.contact_id === this.state.contact_relation_id)
                source = data === Constants.typeAction.SmsEnvoi && contactRelation && contactRelation.portable || data === Constants.typeAction.EmailEnvoi && contactRelation && contactRelation.email || source || ''
            } else {
                source = data === Constants.typeAction.SmsEnvoi && this.props.contact_portable || data === Constants.typeAction.EmailEnvoi && this.props.contact_email || source || ''
            }
            if (this.state.user_assign_id) {
                const userAssign = this.state.GroupeUtilisateurOptions.find(g => g.value === this.state.user_assign_id)
                portable_retour = userAssign.portable
                email_retour = userAssign.email
            } else {
                portable_retour = User.User.get().portable
                email_retour = User.User.get().email
            }
        }
        if ((this.state.type_action_id === Constants.typeAction.SmsEnvoi || this.state.type_action_id === Constants.typeAction.EmailEnvoi)
            && name === 'user_assign_id' && data) {
            const userAssign = this.state.GroupeUtilisateurOptions.find(g => g.value === data)
            portable_retour = userAssign.portable
            email_retour = userAssign.email
        } else if ((this.state.type_action_id === Constants.typeAction.SmsEnvoi || this.state.type_action_id === Constants.typeAction.EmailEnvoi)
            && name === 'contact_relation_id' && data) {
            const contactRelation = (this.state.relations || []).find(r => r.contact_id === data)
            source = this.state.type_action_id === Constants.typeAction.SmsEnvoi && contactRelation.portable || this.state.type_action_id === Constants.typeAction.EmailEnvoi && contactRelation.email || source || ''
        }

        if (name === 'type_action_id' && data === Constants.typeAction.EmailEnvoi && this.state.dossier && this.state.dossier.id) {
            console.log(this.state)
            libelle = `[Euresto] Ticket #${this.state.dossier.id} - ${this.state.dossier.libelle}`
        }

        if (source !== this.state.source) {
            keySource = Utils.getRandomNumber()
        }

        this.setState({
            source: source,
            libelle: libelle,
            portable_retour: portable_retour,
            email_retour: email_retour,
            [name]: data,
            keySource: keySource,
        }, () => {
            this.setState({
                messageToShow: messageToShow,
            })
        })
    }

    copyLinkAction = action => e => {
        e.stopPropagation()
        e.preventDefault()
        const dossier_id = action.dossier_id
        const classeur_id = action.classeur_id
        const link = window.location + `?action_id=${action.id}&${!dossier_id && ('classeur_id=' + classeur_id) || (`dossier_id=${dossier_id}&classeur_id=${classeur_id}`)}&UserTabSelected=2`
        var textArea = document.createElement('textarea')
        textArea.value = link
        document.body.appendChild(textArea)
        textArea.select()
        document.execCommand('Copy')
        textArea.remove()
    }

    render() {
        return (
            <Grid container style={{ margin: 0, padding: 0 }} spacing={0}>
                <EurestoDiv
                    paddingTopBody={0}
                    elemsLeft={[<Grid container style={{ padding: 0, margin: 0, zIndex: 10, height: '100%' }} spacing={0}
                        justify={'flex-end'}
                        alignContent={'center'}
                        alignItems={'center'}
                        wrap={'nowrap'}>

                        {!this.dossierOuvert() && this.state.actions.findIndex(act =>
                            act.type_action_id !== Constants.typeAction.FermetureDossier && act.type_action_id !== Constants.typeAction.ModificationDossier && act.type_action_id !== Constants.typeAction.CreationDossier
                        ) === -1 &&
                            <Grid item style={{ margin: 0, padding: 0 }}>
                                <Button variant="contained" size="small" style={{ marginRight: 5, padding: '1px 5px' }}
                                    onClick={() => this.handleDeleteDossier(1)}
                                    className={'EurestoPrimary'}><i
                                        className={'ei-sdd_dossier_ferme EurestoSecondary--text'} />&nbsp;
                                <span
                                        className={'EurestoText--text'}>Supprimer</span></Button>
                            </Grid>
                        }
                        {!this.dossierOuvert() &&
                            <Grid item style={{ margin: 0, padding: 0 }}>
                                <Button variant="contained" size="small" style={{ padding: '1px 5px' }}
                                    onClick={() => this.handleReopenCloseDossier(1)}
                                    className={'EurestoPrimary'}><i
                                        className={'ei-sdd_dossier EurestoSecondary--text'} />&nbsp;
                                <span
                                        className={'EurestoText--text'}>Réouvrir</span></Button>
                            </Grid>
                            ||
                            this.state.dossier && this.state.dossier.id &&
                            <Grid item style={{ margin: 0, padding: 0 }}>
                                <Button size="small" style={{ padding: '1px 5px' }}
                                    onClick={() => this.handleReopenCloseDossier(0)}
                                    className={'EurestoPrimary'}><i
                                        className={'ei-commun_archiver EurestoSecondary--text'} />&nbsp;
                                <span
                                        className={'EurestoText--text'}>Fermer</span></Button>
                            </Grid>
                        }
                        {this.state.dossier && this.state.dossier.id &&
                            <Grid item style={{ margin: 0, padding: 0 }}>
                                <Button size="small" style={{ marginLeft: 5, padding: '1px 5px' }}
                                    onClick={() => this.handleClickModalDossier(true, 'update')}
                                    className={'EurestoPrimary'}><i
                                        className={'ei-commun_configuration EurestoSecondary--text'} />&nbsp;
                                <span
                                        className={'EurestoText--text'}>Configurer</span></Button>
                            </Grid>
                        }
                    </Grid>]}
                    titleStyle={{ padding: 0 }}
                    title={<Grid container wrap={'nowrap'} spacing={8} alignItems={'center'}
                        justify={'space-between'}
                        style={{
                            margin: 0,
                            boxShadow: '0px 1px ' + EurestoColor('EurestoPrimary'),
                            padding: '0px 5px',
                            width: '100%',
                            maxWidth: '100%',
                        }}>
                        <span style={{
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            background: 'white',
                            overflow: 'hidden'
                        }}>
                            {
                                this.state.dossierId && (typeof this.state.dossierId === 'string' && Data.get(Constants.module.SDD, Constants.donnee.classeur, {
                                    ...(this.state.client_id !== 1 && { visible: 1 } || {}),
                                    id: this.state.dossierId.replace('default_', '')
                                }).libelle
                                    ||
                                    (this.state.dossierId + ' - ' +
                                        (this.state.dossiers.find(d => parseInt(d.id) === parseInt(this.state.dossierId)) || {}).libelle))
                            }
                        </span>
                    </Grid>
                    }>

                    <Grid item style={{
                        margin: 0, padding: 0, paddingRight: 7, width: 250, minWidth: 250, maxWidth: 250,
                        borderRight: 'thin solid ' + EurestoColor('EurestoPrimary')
                    }}>
                        <Grid wrap={'nowrap'} container direction={'column'} style={{
                            margin: 0,
                            padding: 0,
                            height: User.CalculHeight.getHeightWanted(70 + this.props.maxHeightWindow, ' - 68px '),
                            maxHeight: User.CalculHeight.getHeightWanted(70 + this.props.maxHeightWindow, ' - 68px '),
                            overflowY: 'auto',
                            width: 250,
                            maxWidth: 250,
                            minWidth: 250
                        }}>
                            {(this.state.relations || []).length > 0 && <Grid container style={{
                                margin: 0,
                                padding: 0,
                                width: 249,
                                borderBottom: '1px solid rgba(255,255,255,0.20)',
                                borderTop: '1px solid rgba(0,0,0,0.80)',
                                backgroundColor: 'lightgrey',
                                cursor: 'pointer'
                            }} spacing={0} justify={'space-between'}
                                alignItems={'center'}
                                onClick={() => this.setState({
                                    relationExpended: !(this.state.relationExpended || false)
                                })}>
                                <strong style={{ marginLeft: 3 }}>Relations</strong>

                                <Grid item style={{ margin: 0, padding: 0, marginRight: 3 }}>
                                    <i
                                        className={'ei-commun_carre_' + (this.state.relationExpended ? 'moins' : 'plus') + ' EurestoPrimary--text'} />
                                </Grid>
                            </Grid>}
                            {(this.state.relations || []).length > 0 && this.state.relationExpended &&
                                <Grid container
                                    style={{
                                        margin: 0,
                                        padding: 0,
                                        width: 249,
                                        borderTop: '2px solid rgba(0,0,0,0.80)',
                                        borderBottom: '1px solid lightgrey',
                                        backgroundColor: '#F9F9F9'
                                    }}
                                    spacing={0} justify={'flex-start'}
                                    alignItems={'flex-start'}>
                                    {
                                        (this.state.relations || []).map((r, i) =>
                                            <Grid key={r.contact_id + '-' + r.relation_id + ' _' + this.state.client_id}
                                                item xs={12}
                                                style={{
                                                    margin: 0,
                                                    padding: 5,
                                                    textDecoration: 'underline'
                                                }}
                                            >
                                                <Grid container style={{ margin: 0, padding: 0 }} spacing={0}
                                                    justify={'flex-start'}
                                                    alignItems={'flex-start'}>
                                                    < Grid item xs={12} style={{
                                                        margin: 0,
                                                        padding: 0,
                                                        textAlign: 'left'
                                                    }}><NavLink
                                                        to={'/crm/' + r.contact_id}>{r.contact_libelle} ({Data.get(Constants.module.CRM, Constants.donnee.relation, { id: r.relation_id }) && Data.get(Constants.module.CRM, Constants.donnee.relation, { id: r.relation_id }).libelle})</NavLink></Grid>
                                                </Grid>
                                            </Grid>
                                        )
                                    }
                                </Grid>}
                            <Grid container style={{
                                margin: 0,
                                padding: 2.5,
                                borderTop: (this.state.relations || []).length > 0 && '2px solid rgba(0,0,0,0.80)' || ''
                            }}
                                spacing={0} alignItems={'stretch'} justify={'flex-start'}
                                direction={'column'}>
                                {
                                    this.state.client_id && Data.list(Constants.module.SDD, Constants.donnee.classeur, {
                                        classeur_id: null,
                                        ...(this.state.client_id !== 1 && { visible: 1 } || {}),
                                    }).map(c => (
                                        this.showClasseurs(c)
                                    ))
                                }
                                {
                                    this.state.client_id && <span onClick={() => this.toggleShowStatusTicket()}
                                        className={'cursor-pointer EurestoPrimary--text'}
                                        style={{
                                            boxShadow: '0 8px 16px 0 rgba(0,0,0,0.2), 0 6px 20px 0 rgba(0,0,0,0.19)',
                                            backgroundColor: '#DFDFDF',
                                            margin: -2.5,
                                            padding: 5,
                                            position: 'absolute',
                                            bottom: 32,
                                            width: 249,
                                        }}><i
                                            className={`EurestoPrimary--text fa fa-${this.state.showOnlyOpenTicket && 'times-circle-o' || 'check-circle-o'}`} />&nbsp;{this.state.showOnlyOpenTicket && 'Afficher les tickets fermés' || 'Afficher seulement les tickets ouverts'}</span>
                                }
                                {
                                    this.state.client_id &&
                                    <span onClick={() => this.handleClickModalDossier(true, 'add')}
                                        className={'cursor-pointer EurestoPrimary--text'} style={{
                                            boxShadow: '0 8px 16px 0 rgba(0,0,0,0.2), 0 6px 20px 0 rgba(0,0,0,0.19)',
                                            backgroundColor: '#DFDFDF',
                                            margin: -2.5,
                                            padding: 5,
                                            position: 'absolute',
                                            bottom: 3,
                                            borderBottomLeftRadius: 5,
                                            width: 249,
                                        }}><i
                                            className={'EurestoPrimary--text ei-commun_ajouter'} />&nbsp;Nouveau Ticket</span>
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs style={{ margin: 0, padding: 0 }}>
                        <DefaultUpload key={this.state.keyUpload} style={{ border: 'none', width: '100%' }}
                            contact_id={this.state.client_id} catchedUploadFile={this.state.type_action_id === Constants.typeAction.EmailEnvoi && this.handleMedia} handleUploaded={this.handleUpload}>
                            <Grid container style={{
                                margin: 0,
                                padding: 0,
                                maxHeight: User.CalculHeight.getHeightWanted(80 + this.props.maxHeightWindow),
                                height: User.CalculHeight.getHeightWanted(80 + this.props.maxHeightWindow),
                            }} spacing={0} justify={'center'} alignItems={'center'}>
                                <SplitPane split={'horizontal'} defaultSize={this.dossierOuvert() && '70%' || '100%'}
                                    pane1Style={{
                                        minHeight: this.dossierOuvert() && '30%' || '100%',
                                        maxHeight: this.dossierOuvert() && '70%' || '100%',
                                    }} pane2Style={{
                                        minHeight: this.dossierOuvert() && '30%' || 0,
                                        maxHeight: this.dossierOuvert() && '70%' || 0,
                                    }}>
                                    <Grid container style={{
                                        height: '100%',
                                        margin: 0,
                                        padding: 0,
                                        overflowY: 'auto',
                                        width: '100%',
                                        background: 'white'
                                    }} spacing={0} justify={'flex-start'} alignItems={'flex-start'}
                                        alignContent={'flex-start'}>

                                        {this.state.dossiers.find(d => d.dossier_id && d.dossier_id ===
                                            this.state.dossierId && typeof this.state.dossierId === 'number' && this.state.dossierId &&
                                            (d.type_dossier === 49 || d.type_dossier === 50 || d.classeur_id === 49 || d.classeur_id === 50))
                                            && <Grid container style={{
                                                height: 30,
                                                top: 0,
                                                margin: 0,
                                                padding: 5,
                                                position: 'absolute',
                                                width: '100%',
                                                color: 'white',
                                                background: EurestoColor('EurestoError')
                                            }} spacing={0} justify={'space-between'} alignItems={'flex-start'}
                                                alignContent={'space-between'}>
                                                {(() => {
                                                    const dossier = this.state.dossiers.find(d => d.dossier_id && d.dossier_id ===
                                                        this.state.dossierId && typeof this.state.dossierId === 'number' && this.state.dossierId && (d.type_dossier === 49 || d.type_dossier === 50 || d.classeur_id === 49 || d.classeur_id === 50))
                                                    const isCas = dossier.classeur_id === 49 || dossier.classeur_id === 50
                                                    return isCas && <React.Fragment>
                                                        <Grid item>
                                                            {`${dossier.classeur_id === 49 && 'Développement :' || 'Bug :'} ${dossier.libelle}`}
                                                        </Grid>
                                                        <Grid item>
                                                            <Grid container justify={'center'} alignContent={'center'}
                                                                alignItems={'center'}
                                                                onClick={() => this.handleClickModalTicketCas(true)}
                                                                className={'cursor-pointer EurestoPrimary'}
                                                                style={{
                                                                    fontSize: 15,
                                                                    borderRadius: '50%',
                                                                    width: 20,
                                                                    height: 20
                                                                }}>{(this.state.dossiersCas || []).length}</Grid>
                                                        </Grid>
                                                    </React.Fragment>
                                                        || <React.Fragment>
                                                            <Grid item>
                                                                {`${dossier.type_dossier === 49 && 'Développement :' || 'Bug :'} ${dossier.dossier_parent_libelle}`}
                                                            </Grid>
                                                            <Grid item>
                                                                <i onClick={() => {
                                                                    browserHistory.push({
                                                                        pathname: '/crm/' + dossier.dossier_parent_contact_id,
                                                                        state: {
                                                                            dossier_id: dossier.dossier_parent_id || undefined,
                                                                            classeur_id: dossier.type_dossier,
                                                                            UserTabSelected: 2,
                                                                            dossier_status: dossier.dossier_parent_status
                                                                        }
                                                                    })
                                                                }} className={'ei-commun_connexion cursor-pointer'}
                                                                    style={{ fontSize: 15 }} />
                                                            </Grid>
                                                        </React.Fragment>
                                                })()
                                                }
                                            </Grid>}
                                        <Grid container style={{
                                            height: this.state.dossiers.find(d => d.dossier_id && d.dossier_id ===
                                                this.state.dossierId && typeof this.state.dossierId === 'number' && this.state.dossierId && (d.type_dossier === 49 || d.type_dossier === 50 || d.classeur_id === 49 || d.classeur_id === 50))
                                                && 'calc(100% - 30px)' || '100%',
                                            margin: this.state.dossiers.find(d => d.dossier_id && d.dossier_id ===
                                                this.state.dossierId && typeof this.state.dossierId === 'number' && this.state.dossierId && (d.type_dossier === 49 || d.type_dossier === 50 || d.classeur_id === 49 || d.classeur_id === 50))
                                                && '30px 0 0 0' || 0,
                                            padding: 0,
                                            overflowY: 'auto',
                                            width: '100%',
                                            background: 'white'
                                        }} spacing={0} justify={'flex-start'} alignItems={'flex-start'}
                                            alignContent={'flex-start'}>
                                            {
                                                this.state.client_id && this.state.dossiers && this.state.actions.filter((a, i) => {
                                                    const dossier_id = this.state.dossierId && typeof this.state.dossierId === 'number' && this.state.dossierId || undefined
                                                    const classeur_id = this.state.dossierId && (typeof this.state.dossierId === 'string' && parseInt(this.state.dossierId.replace('default_', '')) || (this.state.dossiers || []).find(d => parseInt(d.id) === this.state.dossierId) && (this.state.dossiers || []).find(d => parseInt(d.id) === this.state.dossierId).classeur_id)
                                                    return a.classeur_id === classeur_id && ((dossier_id && a.dossier_id === dossier_id) || (dossier_id === undefined && a.dossier_id === null))
                                                }).map((action, i) => {
                                                    return this.action(action, i)
                                                }
                                                )
                                            }
                                            {
                                                this.state.messageConfiguration.map((act, i) => {
                                                    return this.action(act.message, i, act.action)
                                                })
                                            }
                                            <div style={{ float: 'left', clear: 'both' }}
                                                ref={(el) => {
                                                    this.messagesEnd = el
                                                }}>
                                            </div>
                                        </Grid>
                                    </Grid>
                                    {this.dossierOuvert() &&
                                        <Paper style={{
                                            backgroundColor: '#F5F5F5',
                                            width: '100%',
                                            position: 'relative',
                                            height: '100%',
                                            margin: 0,
                                            color: 'inherit',
                                        }}>
                                            <Grid container
                                                style={{ margin: 0, padding: 0, position: 'relative', height: '100%' }}
                                                spacing={0} direction={'column'}
                                                justify={'flex-start'} alignItems={'stretch'} wrap={'nowrap'}>
                                                <Grid container style={{ margin: 0, padding: 0, position: 'relative' }}
                                                    spacing={0}
                                                    direction={'row'}
                                                    justify={'center'} alignItems={'center'} alignContent={'center'}>
                                                    <Grid item xs style={{ margin: 0, padding: 2 }}>
                                                        <ListingModal
                                                            buttonsLeft={[{
                                                                icon: ' ei-commun_ajouter',
                                                                className: 'EurestoSecondary--text EurestoPrimary',
                                                                title: 'Ajouter',
                                                                cb: () => this.handleClickModalRelation(true)
                                                            }]}
                                                            inputStyle={{
                                                                marginBottom: 0
                                                            }}
                                                            columns={[
                                                                {
                                                                    id: 'value',
                                                                    show: false,
                                                                    type: 'string',
                                                                },
                                                                {
                                                                    id: 'label',
                                                                    headerClassName: 'EurestoPrimary EurestoText--text',
                                                                    filters: ['search'],
                                                                    header: <strong style={{
                                                                        display: 'block',
                                                                        width: '100%'
                                                                    }}>{EurestoI18n.t('commun:Contact')}</strong>,
                                                                    type: 'string',
                                                                },
                                                                {
                                                                    id: 'relation',
                                                                    headerClassName: 'EurestoPrimary EurestoText--text',
                                                                    filters: ['search'],
                                                                    header: <strong style={{
                                                                        display: 'block',
                                                                        width: '100%'
                                                                    }}>{EurestoI18n.t('commun:Relation')}</strong>,
                                                                    type: 'string',
                                                                },
                                                            ]}
                                                            style={{
                                                                maxHeight: User.CalculHeight.getHeightWanted(300),
                                                            }}
                                                            key={this.state.contact_relation_id + '_key_contact_intern'}
                                                            title={EurestoI18n.t('crm:Contact interne')}
                                                            onClick={this.recherche}
                                                            name={'contact_relation_id'}
                                                            data={(this.state.relations || []).map(r => ({
                                                                label: r.contact_libelle,
                                                                value: r.contact_id,
                                                                relation: (Data.get(Constants.module.CRM, Constants.donnee.relation, { id: r.relation_id }) || {}).libelle
                                                            }))}
                                                            value={this.state.contact_relation_id}
                                                            libelle={((this.state.relations || []).map(r => ({
                                                                label: r.contact_libelle,
                                                                value: r.contact_id
                                                            })).find(g => g.value === this.state.contact_relation_id) || {}).label} />
                                                    </Grid>
                                                    <Grid item xs style={{ margin: 0, padding: 2 }}>
                                                        <ListingModal
                                                            hideHeader
                                                            style={{
                                                                maxHeight: User.CalculHeight.getHeightWanted(300),
                                                            }}
                                                            inputStyle={{
                                                                marginBottom: 0
                                                            }}
                                                            key={this.state.user_assign_id + '_key_assign'}
                                                            title={EurestoI18n.t('crm:Assignée à')}
                                                            value={this.state.user_assign_id}
                                                            data={this.state.GroupeUtilisateurOptions.filter(r => !r.archive_id)}
                                                            onClick={this.recherche}
                                                            name={'user_assign_id'}
                                                            libelle={this.state.user_assign_id && (this.state.GroupeUtilisateurOptions.find(g => g.value === this.state.user_assign_id) || {}).label} />
                                                    </Grid>
                                                    {this.state.user_assign_id &&
                                                        <React.Fragment>
                                                            <Grid item xs style={{ margin: 0, padding: 2 }}>
                                                                <DatePicker
                                                                    disabled={this.state.action_id_update}
                                                                    disablePast
                                                                    title={EurestoI18n.t('crm:Date d\'échéance')}
                                                                    key={this.state.date_echeance + '_key_date_echeance'}
                                                                    name={'date_echeance'}
                                                                    onChange={this.recherche}
                                                                    value={this.state.date_echeance}
                                                                    style={{
                                                                        marginBottom: 0
                                                                    }}
                                                                />
                                                            </Grid>
                                                            <Grid item xs style={{ margin: 0, padding: 2 }}>
                                                                <Select name={'importance'}
                                                                    title={EurestoI18n.t('commun:Importance')}
                                                                    autoComplete={false}
                                                                    default={0}
                                                                    inputStyle={{
                                                                        marginBottom: 0
                                                                    }}
                                                                    onChange={this.recherche}
                                                                    value={this.state.importance}
                                                                    options={[{
                                                                        label: 'Haute',
                                                                        value: 1
                                                                    }, {
                                                                        label: 'Normal',
                                                                        value: 0
                                                                    }, {
                                                                        label: 'Faible',
                                                                        value: -1
                                                                    }]}
                                                                />
                                                            </Grid>
                                                        </React.Fragment>}
                                                    <Grid item style={{ margin: 2, padding: 2 }}>
                                                        <Grid container style={{ margin: 0, padding: 0, minWidth: 20 }}
                                                            spacing={0}
                                                            direction={'column'}
                                                            justify={'center'} alignItems={'center'}
                                                            alignContent={'center'}>
                                                            <Button
                                                                size="small"
                                                                style={{ border: `1px solid ${EurestoColor('primary')}` }}
                                                                className={`EurestoText ${(this.state.medias || []).length > 0 && 'EurestoSecondary--text' || 'EurestoPrimary--text'}`}
                                                                disabled={!this.state.dossierId}>
                                                                {this.actionAttachments()}
                                                            </Button>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item style={{ margin: 2, padding: 2 }}>
                                                        <Grid container style={{ margin: 0, padding: 0, minWidth: 50 }}
                                                            spacing={0}
                                                            direction={'column'}
                                                            justify={'center'} alignItems={'center'}
                                                            alignContent={'center'}>
                                                            <ButtonGroup variant="contained" aria-label="split button">
                                                                {this.actionTypeActionId()}
                                                                <Button
                                                                    size="small"
                                                                    onClick={this.sendMessage}
                                                                    className={'EurestoText--text EurestoSecondary'}
                                                                    disabled={!this.state.dossierId}>
                                                                    <span>&nbsp;Envoyer&nbsp;</span></Button>
                                                            </ButtonGroup>
                                                        </Grid>
                                                    </Grid>

                                                    {
                                                        (this.state.type_action_id === Constants.typeAction.SmsEnvoi
                                                            || this.state.type_action_id === Constants.typeAction.EmailEnvoi
                                                        ) && <Grid item xs={12} style={{ margin: 0, padding: 0 }}>
                                                            <Grid container
                                                                style={{ margin: 0, padding: 0, position: 'relative' }}
                                                                spacing={0}
                                                                direction={'row'}
                                                                justify={'center'} alignItems={'center'}
                                                                alignContent={'center'}>
                                                                {this.state.type_action_id === Constants.typeAction.SmsEnvoi &&
                                                                    <React.Fragment>
                                                                        <Grid item xs style={{ margin: 0, padding: 2 }}
                                                                            key={this.state.keySource + "-" + this.state.contact_relation_id + '_key_contact_intern_phone_' + this.state.type_action_id}>
                                                                            <PhoneInput name={'source'}
                                                                                value={this.state.source}
                                                                                onChange={this.recherche}
                                                                                title={EurestoI18n.t('À')}
                                                                                style={{
                                                                                    marginBottom: 0
                                                                                }} />
                                                                        </Grid>
                                                                    </React.Fragment>
                                                                }
                                                                {this.state.type_action_id === Constants.typeAction.EmailEnvoi &&
                                                                    <React.Fragment>
                                                                        <Grid item xs style={{ margin: 0, padding: 2 }}
                                                                            key={this.state.keySource + "-" + this.state.contact_relation_id + '_key_contact_intern_email_' + this.state.type_action_id}>
                                                                            <Input name={'source'} value={this.state.source}
                                                                                onChange={this.recherche}
                                                                                title={EurestoI18n.t('À')}
                                                                                style={{
                                                                                    marginBottom: 0
                                                                                }} />
                                                                        </Grid>
                                                                        <Grid item xs style={{ margin: 0, padding: 2 }}>
                                                                            <Input name={'source_cc'}
                                                                                value={this.state.source_cc}
                                                                                onChange={this.recherche}
                                                                                title={EurestoI18n.t('CC')}
                                                                                style={{
                                                                                    marginBottom: 0
                                                                                }} />
                                                                        </Grid>
                                                                        <Grid item xs style={{ margin: 0, padding: 2 }}>
                                                                            <Input name={'source_cci'}
                                                                                value={this.state.source_cci}
                                                                                onChange={this.recherche}
                                                                                title={EurestoI18n.t('CCI')}
                                                                                style={{
                                                                                    marginBottom: 0
                                                                                }} />
                                                                        </Grid>
                                                                    </React.Fragment>
                                                                }
                                                                <Grid item xs style={{ margin: 0, padding: 2 }}
                                                                    key={this.state.user_assign_id + '_key_user_assign_email_' + this.state.type_action_id}>
                                                                    <Input name={'email_retour'}
                                                                        value={this.state.email_retour}
                                                                        onChange={this.recherche}
                                                                        title={EurestoI18n.t('Email Retour')}
                                                                        style={{
                                                                            marginBottom: 0
                                                                        }} />
                                                                </Grid>
                                                                <Grid item xs style={{ margin: 0, padding: 2 }}
                                                                    key={this.state.user_assign_id + '_key_user_assign_phone_' + this.state.type_action_id}>
                                                                    <PhoneInput name={'portable_retour'}
                                                                        value={this.state.portable_retour}
                                                                        onChange={this.recherche}
                                                                        title={EurestoI18n.t('Portable retour')}
                                                                        style={{
                                                                            marginBottom: 0
                                                                        }} />
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    }
                                                    {
                                                        this.state.type_action_id === Constants.typeAction.EmailEnvoi &&
                                                        <Grid item xs={12} style={{ margin: 0, padding: 0 }}>
                                                            <Grid container
                                                                style={{ margin: 0, padding: 0, position: 'relative' }}
                                                                spacing={0}
                                                                direction={'row'}
                                                                justify={'center'} alignItems={'center'}
                                                                alignContent={'center'}>
                                                                <Grid item xs style={{ margin: 0, padding: 2 }}>
                                                                    <Input name={'libelle'} value={this.state.libelle}
                                                                        onChange={this.recherche}
                                                                        title={EurestoI18n.t('Sujet')}
                                                                        style={{
                                                                            marginBottom: 0
                                                                        }} />
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    }
                                                </Grid>
                                                <Wysiwyg onChange={this.onChangeMessage}
                                                    key={this.state.keyWysiwyg + '-' + this.state.type_action_id + '-' + this.state.user_assign_id + '-' + this.state.contact_relation_id}
                                                    buttons={this.state.type_action_id === Constants.typeAction.SmsEnvoi && []}
                                                    maxHeight={`calc(100% - (42px${this.state.type_action_id === Constants.typeAction.SmsEnvoi && ' * 2' ||
                                                        this.state.type_action_id === Constants.typeAction.EmailEnvoi && ' * 3' || ''}))`}
                                                    name='message'
                                                    disabled={!this.state.dossierId}
                                                    value={this.state.message} />
                                            </Grid>
                                        </Paper>
                                    }
                                </SplitPane>
                            </Grid>
                        </DefaultUpload>
                    </Grid>
                </EurestoDiv>
                {this.modalDossier()}
                {this.modalDelete()}
                {this.modalContact()}
                {this.modalCas()}
                {this.modalTicketCas()}
                {this.modalRelation()}
                {this.modalConfirmClosed()}
                <ApercuImage isOpen={this.state.viewFichier} open={this.state.viewFichier}
                    images={this.state.medias_liens || this.state.media_lien && [{
                        src: this.state.media_lien
                    }] || []} onClose={() => this.onCloseFichierModal(false)} />
            </Grid>
        )
    }

    onAddMedia = () => {
        const medias = this.state.medias || []
        medias.push({
            media_libelle: ''
        })
        this.setState({
            medias: medias
        }, this.forceUpdate)
    }

    onChangeMedia = (i) => (data, name) => {
        const { medias } = this.state
        const media = medias[i]

        media[name] = data
        medias[i] = media
        this.setState({
            medias: medias
        }, this.forceUpdate)

    }

    onDeleteMedia = (i) => {
        const { medias } = this.state
        medias.splice(i, 1)
        this.setState({
            medias: medias
        }, this.forceUpdate)
    }

    catchedUploadFile = (i) => (file, base64) => {
        const { medias } = this.state
        const media = medias[i]
        console.log(file)

        media.media_base64 = base64
        media.media_type = file.type
        media.media_extension = file.name.split('.').slice(-1)[0]
        media.media_libelle = media.media_libelle || media.media_extension && file.name.replace("." + media.media_extension, "") || file.name
        media.media_key = Utils.getRandomNumber()
        console.log(media.media_libelle, media.media_extension && file.name.replace("." + media.media_extension, "") || file.name)
        medias[i] = media
        this.setState({
            medias: medias
        }, this.forceUpdate)
    }

    handleCloseElTypeActionId = () => {
        this.setState({
            anchorTypeActionIdEl: null
        })
    }

    handleClickElTypeActionId = (event) => {
        if (event.target.className.indexOf('anchorElementTypeAction') !== -1) {
            this.setState({
                anchorTypeActionIdEl: event.target
            })
        }
    }

    handleCloseElAttachmentActionId = () => {
        this.setState({
            anchorAttachmentActionIdEl: null
        })
    }

    handleClickElAttachmentActionId = (event) => {
        if (event.target.className.indexOf('anchorElementAttachmentAction') !== -1) {
            this.setState({
                anchorAttachmentActionIdEl: event.target
            })
        }
    }

    actionAttachments = () => {
        return (
            <Grid container style={{ margin: 0, padding: 5, width: 20 }}
                spacing={0}
                direction={'column'}
                justify={'center'} alignItems={'center'}
                alignContent={'center'}>
                <i className={`anchorElementAttachmentAction fa fa-paperclip`}
                    aria-owns={this.state.anchorAttachmentActionIdEl ? 'action-menu-type-action-upload' : null}
                    aria-haspopup="true"
                    onClick={(event) => this.handleClickElAttachmentActionId(event)}
                    style={{ borderRadius: 5, margin: '0px 2px', cursor: 'pointer', fontSize: 20 }}>
                    <Menu
                        style={{ paddingRight: 5, paddingLeft: 5 }}
                        id={'action-menu-type-action-upload'}
                        keepMounted
                        anchorEl={this.state.anchorAttachmentActionIdEl || null}
                        open={Boolean(this.state.anchorAttachmentActionIdEl) || false}
                        onClose={this.handleCloseElAttachmentActionId}>
                        <MenuList>
                            <MenuItem>
                                <Title
                                    style={{ padding: '5px 5px' }} title={'Pièces jointes'}
                                    buttons={
                                        <button type="button" onClick={this.onAddMedia}
                                            className="text-success ei-commun_ajouter"
                                            style={{ display: 'inline-block', margin: '0px 5px' }} />}>

                                    {
                                        (this.state.medias || []).map((data, index) => (
                                            <Grid key={index} container style={{ margin: 0, padding: 0 }} spacing={0} justify={'center'}
                                                alignItems={'center'}>
                                                <Grid item style={{ margin: 0, padding: 0 }}>
                                                    <DefaultUpload clickable style={{ height: 31, maxHeight: 31, width: 31, overflow: 'hidden', margin: '2.5px 5px 2.5px 2.5px', borderRadius: '50%' }}
                                                        catchedUploadFile={this.catchedUploadFile(index)}>
                                                        {data.media_type && data.media_type.indexOf('image/') === -1 ? <i className={'ei-module_documentation fa-2x'} /> : <img style={{ borderRadius: '50%' }} width={30} height={30}
                                                            src={`data:${data.type};base64,${data.media_base64}`} alt={data.media_libelle} />}
                                                    </DefaultUpload>
                                                </Grid>
                                                <Grid item xs style={{ margin: 0, padding: 0 }}>
                                                    <Input
                                                        key={data.media_key}
                                                        title={EurestoI18n.t('commun:Nom')}
                                                        onChange={this.onChangeMedia(index)}
                                                        name={'media_libelle'}
                                                        value={data.media_libelle}
                                                    />
                                                </Grid>
                                                <Grid item>
                                                    <button type="button" onClick={() => this.onDeleteMedia(index)}
                                                        className="text-danger ei-commun_enlever" />
                                                </Grid>
                                            </Grid>
                                        ))
                                    }
                                </Title>
                            </MenuItem>
                        </MenuList>
                    </Menu>
                </i>
            </Grid>
        )
    }

    actionTypeActionId = () => {
        return (
            <Grid container style={{ margin: 0, padding: 5, width: 20 }}
                spacing={0}
                direction={'column'}
                justify={'center'} alignItems={'center'}
                alignContent={'center'}>
                <i className={`EurestoPrimary--text anchorElementTypeAction ei-${this.state.type_action_id === Constants.typeAction.EmailEnvoi && 'crm_campagne_email'
                    || this.state.type_action_id === Constants.typeAction.SmsEnvoi && 'crm_campagne_sms'
                    || this.state.type_action_id === Constants.typeAction.Message && 'commun_envoyer'
                    || this.state.type_action_id === Constants.typeAction.MessagePrive && 'crm_confidentiel'
                    }`}
                    aria-owns={this.state.anchorTypeActionIdEl ? 'action-menu-type-action' : null}
                    aria-haspopup="true"
                    onClick={(event) => this.handleClickElTypeActionId(event)}
                    style={{ borderRadius: 5, margin: '0px 2px', cursor: 'pointer', fontSize: 20 }}>
                    <Menu
                        style={{ paddingRight: 5, paddingLeft: 5 }}
                        id={'action-menu-type-action'}
                        keepMounted
                        anchorEl={this.state.anchorTypeActionIdEl || null}
                        open={Boolean(this.state.anchorTypeActionIdEl) || false}
                        onClose={this.handleCloseElTypeActionId}>
                        <MenuList>
                            <MenuItem style={{
                                backgroundColor: this.state.type_action_id === Constants.typeAction.Message && EurestoColor('EurestoPrimary'),
                                color: this.state.type_action_id === Constants.typeAction.Message && EurestoColor('EurestoText'),
                                padding: 2.5,
                            }}
                                className={this.state.type_action_id === Constants.typeAction.Message && 'EurestoPrimary EurestoText--text' || ''}
                                onClick={() => {
                                    this.recherche(Constants.typeAction.Message, 'type_action_id')
                                    this.handleCloseElTypeActionId()
                                }}>
                                <Grid container style={{ margin: 0, padding: 0, height: '100%' }} spacing={0}
                                    justify={'flex-start'}
                                    alignContent={'center'}
                                    alignItems={'center'}>
                                    <i style={{ fontSize: 20, padding: '0 5px' }} className={`ei-commun_envoyer`} />Message/Tâche
                                </Grid>
                            </MenuItem>
                            <MenuItem style={{
                                backgroundColor: this.state.type_action_id === Constants.typeAction.SmsEnvoi && EurestoColor('EurestoPrimary'),
                                color: this.state.type_action_id === Constants.typeAction.SmsEnvoi && EurestoColor('EurestoText'),
                                padding: 2.5,
                            }}
                                className={this.state.type_action_id === Constants.typeAction.SmsEnvoi && 'EurestoPrimary EurestoText--text' || ''}
                                onClick={() => {
                                    this.recherche(Constants.typeAction.SmsEnvoi, 'type_action_id')
                                    this.handleCloseElTypeActionId()
                                }}>
                                <Grid container style={{ margin: 0, padding: 0 }} spacing={0} justify={'flex-start'}
                                    alignContent={'center'}
                                    alignItems={'center'}>
                                    <i style={{ fontSize: 20, padding: '0 5px' }} className={`ei-crm_campagne_sms`} />SMS
                                </Grid>
                            </MenuItem>
                            <MenuItem style={{
                                backgroundColor: this.state.type_action_id === Constants.typeAction.EmailEnvoi && EurestoColor('EurestoPrimary'),
                                color: this.state.type_action_id === Constants.typeAction.EmailEnvoi && EurestoColor('EurestoText'),
                                padding: 2.5,
                            }}
                                className={this.state.type_action_id === Constants.typeAction.EmailEnvoi && 'EurestoPrimary EurestoText--text' || ''}
                                onClick={() => {
                                    this.recherche(Constants.typeAction.EmailEnvoi, 'type_action_id')
                                    this.handleCloseElTypeActionId()
                                }}>
                                <Grid container style={{ margin: 0, padding: 0 }} spacing={0} justify={'flex-start'}
                                    alignContent={'center'}
                                    alignItems={'center'}>
                                    <i style={{ fontSize: 20, padding: '0 5px' }} className={`ei-crm_campagne_email`} />Email
                                </Grid>
                            </MenuItem>
                            <MenuItem style={{
                                backgroundColor: this.state.type_action_id === Constants.typeAction.MessagePrive && EurestoColor('EurestoPrimary'),
                                color: this.state.type_action_id === Constants.typeAction.MessagePrive && EurestoColor('EurestoText'),
                                padding: 2.5,
                            }}
                                className={this.state.type_action_id === Constants.typeAction.MessagePrive && 'EurestoPrimary EurestoText--text' || ''}
                                onClick={() => {
                                    this.recherche(Constants.typeAction.MessagePrive, 'type_action_id')
                                    this.handleCloseElTypeActionId()
                                }}>
                                <Grid container style={{ margin: 0, padding: 0 }} spacing={0} justify={'flex-start'}
                                    alignContent={'center'}
                                    alignItems={'center'}>
                                    <i style={{ fontSize: 20, padding: '0 5px' }} className={`ei-crm_confidentiel`} />Message/Tâche
                                    Privé
                                </Grid>
                            </MenuItem>
                        </MenuList>
                    </Menu>
                </i>
            </Grid>
        )
    }

    modalConfirmClosed = _ => (
        this.state.modalCloseAllUnfinishedAction &&
        <Modal key={this.state.modalCloseAllUnfinishedActionKey} open={this.state.modalCloseAllUnfinishedAction}
            onClose={_ => this.handleModalCloseAllUnfinishedAction(false)}
            grid={{ xs: 3 }}>
            <EurestoDiv
                fromModal={true} style={{
                    margin: 0,
                    padding: 0,
                    overflowY: 'auto'
                }} title={EurestoI18n.t('commun:Confirmation de fermeture du dossier')}
                buttonsLeft={[{
                    icon: ' ei-commun_fermer',
                    className: 'EurestoError--text EurestoText',
                    cb: _ => this.handleModalCloseAllUnfinishedAction(false)
                }]}
                buttonsRight={[{
                    icon: ' ei-commun_valider',
                    className: 'text-success',
                    cb: () => this.closeDossier(0) || this.handleModalCloseAllUnfinishedAction(false)
                }]}>
                <Grid container style={{ margin: 0, padding: 10 }} spacing={0} justify={'flex-start'}
                    alignItems={'center'}>
                    <Grid item style={{ margin: 0, padding: 0 }}>
                        <span style={{
                            wordWrap: 'break-word',
                            width: '100%',
                            whiteSpace: 'initial',
                        }}>{EurestoI18n.t('commun:Ce dossier contient des tâches non traitées. Souhaitez-vous quand même le fermer ? Cela basculera toutes les tâches non traitées, en traitées ') + `(${this.props.libelle})`}</span>
                    </Grid>
                </Grid>
            </EurestoDiv>
        </Modal>
    )

    toggleShowStatusTicket = async () => {
        this.setState({
            showOnlyOpenTicket: !this.state.showOnlyOpenTicket
        })
    }

    onCloseFichierModal = () => {
        this.setState({
            viewFichier: false,
            lien: undefined
        }, () => this.forceUpdate())
    }

    showClasseurs = (c, marginLeft = 0) => {
        const nbDossierTicketOpenInsideClasseur = this.state.dossiers
            .filter(d => (d.dossier_id !== null && d.dossier_id !== undefined && d.classeur_id === c.id)
                || (Data.list(Constants.module.SDD, Constants.donnee.classeur, {
                    classeur_id: c.id,
                    ...(this.state.client_id !== 1 && { visible: 1 } || {}),
                }).findIndex(dossier => dossier.id === d.classeur_id) !== -1))
            .filter(d => d.dossier_id !== null && d.dossier_id !== undefined && d.status !== 0).length

        const nbDossierTicketClosedInsideClasseur = this.state.dossiers
            .filter(d => (d.dossier_id !== null && d.dossier_id !== undefined && d.classeur_id === c.id)
                || (Data.list(Constants.module.SDD, Constants.donnee.classeur, {
                    classeur_id: c.id,
                    ...(this.state.client_id !== 1 && { visible: 1 } || {}),
                }).findIndex(dossier => dossier.id === d.classeur_id) !== -1))
            .filter(d => d.status === 0 || !(d.dossier_id !== null && d.dossier_id !== undefined)).length

        const nbTacheUserInside = this.state.dossiers
            .filter(d => (d.classeur_id === c.id)
                || (Data.list(Constants.module.SDD, Constants.donnee.classeur, {
                    classeur_id: c.id,
                    ...(this.state.client_id !== 1 && { visible: 1 } || {}),
                }).findIndex(dossier => dossier.id === d.classeur_id) !== -1))
            .find(d => this.state.actions_user.find(a => {
                const dossier_id = d.dossier_id || undefined
                const classeur_id = d.classeur_id
                return a.classeur_id === classeur_id && ((dossier_id && a.dossier_id === dossier_id) || (dossier_id === undefined && a.dossier_id === null))
                    || (Data.list(Constants.module.SDD, Constants.donnee.classeur, {
                        classeur_id: classeur_id,
                        ...(this.state.client_id !== 1 && { visible: 1 } || {}),
                    }).findIndex(dossier => dossier.id === a.classeur_id) !== -1)
            })) !== undefined

        const lastActionInfo = (this.state.dossiers || []).find(a => a.dossier_id === null && parseInt(a.classeur_id) === c.id)
        return (<Grid item
            key={c.id + '-' + this.state.client_id + '-' + this.state.classeurExpended[c.id]}
            style={{
                margin: 0,
                position: 'relative',
                paddingBottom: 0,
            }}>
            <Grid onClick={() => {
                const classeurExpended = this.expendClasseur(c.id)
                this.setState({
                    classeurExpended: classeurExpended
                }, () => this.selectDossier(c.id))
            }} container style={{
                margin: 0, padding: 0, cursor: 'pointer', backgroundColor: '#F0F0F0',
                borderLeft: marginLeft && marginLeft + 'px solid #A0A0A0' || '',
                borderTop: this.state.dossierId === 'default_' + c.id && '2px solid ' + EurestoColor('EurestoPrimary') || '',
                borderRight: this.state.dossierId === 'default_' + c.id && '2px solid ' + EurestoColor('EurestoPrimary') || '',
                borderBottom: this.state.dossierId === 'default_' + c.id && ('2px solid ' + EurestoColor('EurestoPrimary')) || '.5px solid rgba(0,0,0,.5)',
            }} spacing={0} direction={'row'}
                alignItems={'flex-start'} justify={'space-between'}>
                <Grid item style={{ margin: 0, padding: 5 }}>
                    <strong>
                        <i style={{ fontWeight: 'bold' }}
                            className={'fa fa-' + (c.icon || ' ei-sdd_classeur') + ' EurestoPrimary--text '} />
                        <span className={'EurestoPrimary--text'}>&nbsp;{c.libelle}</span>
                    </strong>
                </Grid>
                {(lastActionInfo || nbDossierTicketOpenInsideClasseur || nbDossierTicketClosedInsideClasseur || nbTacheUserInside) &&
                    <Grid item style={{ margin: 0, padding: 0, paddingRight: 3, paddingTop: 4.5 }}>
                        <Grid container style={{ height: '100%' }} justify={'center'} alignContent={'center'}
                            alignItems={'center'} direction={'row'}>
                            {nbDossierTicketOpenInsideClasseur &&
                                <Grid container className={'EurestoError'} style={{
                                    color: 'white',
                                    borderRadius: '100%',
                                    width: 22.5,
                                    height: 22.5,
                                    fontSize: 11,
                                    marginRight: (lastActionInfo || nbDossierTicketClosedInsideClasseur || nbTacheUserInside) && 5 || 0
                                }} justify={'center'} alignContent={'center'}
                                    alignItems={'center'} direction={'column'}>
                                    {nbDossierTicketOpenInsideClasseur}
                                </Grid> || ''}
                            {nbDossierTicketClosedInsideClasseur &&
                                <Grid container style={{
                                    color: 'white',
                                    backgroundColor: EurestoColor('disabled', ''),
                                    borderRadius: '100%',
                                    width: 22.5,
                                    height: 22.5,
                                    fontSize: 11,
                                    marginRight: (lastActionInfo || nbTacheUserInside) && 5 || 0
                                }} justify={'center'} alignContent={'center'}
                                    alignItems={'center'} direction={'column'}>
                                    {nbDossierTicketClosedInsideClasseur}
                                </Grid> || ''}
                            {
                                lastActionInfo &&
                                <span className={'EurestoPrimary--text'}
                                    style={{
                                        paddingTop: 2,
                                        fontSize: 11,
                                        color: 'lightgrey',
                                        marginRight: nbTacheUserInside && 5 || 0
                                    }}>
                                    <i
                                        className={'ei-commun_modifier EurestoSecondary--text'} />&nbsp;{moment(lastActionInfo.date_modification).format('DD[/]MM[/]YY LT')}
                                </span> || ''
                            }
                            {nbTacheUserInside &&
                                <Grid container style={{
                                    paddingTop: 2,
                                    color: EurestoColor('EurestoError'),
                                    borderRadius: '100%',
                                    fontWeight: '500',
                                    height: 22.5,
                                    width: 5,
                                    fontSize: 15,
                                }} justify={'center'} alignContent={'center'}
                                    alignItems={'center'} direction={'column'}>
                                    !
                        </Grid> || ''}
                        </Grid>
                    </Grid> || ''}
            </Grid>
            {
                this.state.classeurExpended[c.id] && this.showDossiersClasseur(c.id, 5 + marginLeft)
            }
            {
                this.state.classeurExpended[c.id] && this.state.client_id && Data.list(Constants.module.SDD, Constants.donnee.classeur, {
                    classeur_id: c.id,
                    ...(this.state.client_id !== 1 && { visible: 1 } || {}),
                }).map(c => (
                    this.showClasseurs(c, 5)
                ))
            }
        </Grid>)
    }

    showDossiersClasseur = (classeur_id, marginLeft) => {
        return this.state.dossiers.filter(d => d.classeur_id === classeur_id && d.dossier_id)
            .filter(d => this.state.showOnlyOpenTicket && d.status === 1 || !this.state.showOnlyOpenTicket)
            .map(d => {
                const tacheUserInside = this.state.actions_user.find(a => {
                    const dossier_id = d.dossier_id
                    return a.classeur_id === classeur_id && ((dossier_id && a.dossier_id === dossier_id) || (dossier_id === undefined && a.dossier_id === null))
                })

                return (<Grid key={classeur_id + '-' + d.id + '-' + this.state.client_id} container style={{
                    margin: 0,
                    padding: 0,
                    position: 'relative',
                    marginLeft: (marginLeft - 5) && (marginLeft - 5) + 'px',
                    cursor: 'pointer',
                    width: 'calc(100% - ' + (marginLeft - 7) + 'px)',
                    borderTop: this.state.dossierId === parseInt(d.id) && '2px solid ' + EurestoColor('EurestoPrimary') || '',
                    borderRight: this.state.dossierId === parseInt(d.id) && '2px solid ' + EurestoColor('EurestoPrimary') || '',
                    borderBottom: this.state.dossierId === parseInt(d.id) && ('2px solid ' + EurestoColor('EurestoPrimary')) || '.5px solid rgba(0,0,0,.5',
                    borderLeft: (marginLeft - 5) && (marginLeft - 5) + 'px solid #A0A0A0' || (marginLeft) && (marginLeft) + 'px solid #A0A0A0',
                }} spacing={0}
                    className={'EurestoPrimary--text'}
                    direction={'row'} alignItems={'flex-start'} justify={'flex-start'}
                    alignContent={'flex-start'}
                    onClick={() => this.selectDossier(classeur_id, d.id)}>
                    <Grid item xs={12} style={{ margin: 0, padding: '5px 0px 5px 5px', textAlign: 'left' }}>
                        <strong>
                            <span
                                className={'ei-sdd_dossier ' + (d.status === 0 && 'disabled' || 'EurestoError--text')} />&nbsp;
                            <span
                                className={d.status === 0 && 'disabled' || 'EurestoPrimary--text'}>{d.libelle}</span>
                            {tacheUserInside && <span style={{
                                float: 'right',
                                marginRight: 5,
                                marginTop: -3,
                                color: EurestoColor('EurestoError'),
                                borderRadius: '100%',
                                fontWeight: '500',
                                height: 22.5,
                                width: 3,
                                fontSize: 15,
                            }}>!</span>}
                        </strong>
                        <div style={{
                            fontSize: 10,
                            width: '100%'
                        }}>
                            <div className={'EurestoPrimary--text'}
                                style={{
                                    fontSize: 10,
                                    color: 'lightgrey',
                                    display: 'inline',
                                }}>

                                <i className={'fa fa-clock-o'} />&nbsp;
                                {moment(d.date_creation).format('DD[/]MM[/]YY LT')}
                            </div>
                            <div className={'EurestoPrimary--text pull pull-right'}
                                style={{
                                    fontSize: 10,
                                    color: 'lightgrey',
                                    display: 'inline',
                                    paddingRight: 2
                                }}>
                                <i className={'ei-commun_modifier EurestoSecondary--text'} />&nbsp;
                                {(this.state.dossiers || []).find(a => parseInt(a.dossier_id) === parseInt(d.id))
                                    && moment((this.state.dossiers || []).find(a => parseInt(a.dossier_id) === parseInt(d.id)).date_modification).format('DD[/]MM[/]YY LT')}
                            </div>

                        </div>
                    </Grid>
                </Grid>)
            })
    }

    handleClickElAction = (event, id) => {
        if (event.target.className.indexOf('anchorElement') !== -1) {
            this.setState({
                anchorActionEl: {
                    ...this.state.anchorActionEl || {},
                    [id]: event.target
                }
            })
        }
    }

    handleCloseElAction = (event, id) => {
        this.setState({
            anchorActionEl: {
                ...this.state.anchorActionEl || {},
                [id]: null
            }
        })
    }

    handleClickElFlagAction = (event, id) => {
        if (event.target.className.indexOf('anchorElementFlag') !== -1) {
            this.setState({
                anchorFlagActionEl: {
                    ...this.state.anchorFlagActionEl || {},
                    [id]: event.target
                }
            })
        }
    }

    handleCloseElFlagAction = (event, id) => {
        const flags = this.state.actionFlagsSelected[id] || []
        this.setState({
            actionFlagsSelected: {
                ...(this.state.actionFlagsSelected || {}),
                [id]: null
            },
            anchorFlagActionEl: {
                ...this.state.anchorFlagActionEl || {},
                [id]: null
            }
        }, () => {
            ApiRequest(project.api + 'sdd', {
                requete: 'action',
                action: 'update',
                id: id,
                flags: flags
            })
        })
    }

    handleCloseElDateInterventionAction = (event, id) => {
        this.setState({
            anchorDateInterventionActionEl: {
                ...this.state.anchorDateInterventionActionEl || {},
                [id]: null
            }
        })
    }

    handleClickElDateInterventionAction = (event, id) => {
        if (event.target.className.indexOf('anchorElementDateIntervention') !== -1) {
            this.setState({
                anchorDateInterventionActionEl: {
                    ...this.state.anchorDateInterventionActionEl || {},
                    [id]: event.target
                }
            })
        }
    }

    message = (action) => {
        return (<div>
                <div
                    style={{
                    height: 'auto',
                    padding: '15px 10px',
                    fontSize: 13
                    }} dangerouslySetInnerHTML={{ __html: action.message }} />
                <i
                    style={{ fontSize: '12px' }}>{Data.get(Constants.module.CONFIGURATION, Constants.donnee.utilisateur, { id: action.user_id }) !== undefined ? Data.get(Constants.module.CONFIGURATION, Constants.donnee.utilisateur, { id: action.user_id }).libelle : ''},
                    le {moment(action.date_creation).format('DD[/]MM[/]YY LT')}</i>
        </div>
        )
    }

    htmlReplace = (message, html) => {
        let h = '<span>'

        const body = JSON.parse(message.body)

        h += '<b>Sujet : </b>' + body.subject
        h += '</span>'

        h += '<br/><br/>'

        return h + (html || '')
    }

    action = (action, index, configAction) => {
        const configurationAction = this.state.messageConfiguration.find(m => m.id === action.id)
        const actionConfiguration = configurationAction !== undefined
        return (
            <Grid container style={{
                margin: 0,
                padding: 0,
                width: '100%',
                position: 'relative',
            }}
                spacing={0}
                id={'message_action_' + action.id}
                key={action.id + '_' + action.date_modification}
                justify={'center'}
                direction={'column'}
                alignItems={'flex-start'}>
                {this.state.preSelectedAction === action.id && <div
                    ref={(el) => {
                        this.actionEl = el
                    }} />}
                {
                    action.type_action_id === Constants.typeAction.CreationDossier &&
                    <LineBreakText action={action} color={'green'} />
                    || action.type_action_id === Constants.typeAction.ModificationDossier &&
                    <LineBreakText action={action} color={'orange'} />
                    || action.type_action_id === Constants.typeAction.FermetureDossier &&
                    <LineBreakText action={action} color={EurestoColor('EurestoError')} />
                    ||
                    <div
                        style={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            overflowWrap: 'break-word',
                            whiteSpace: '-moz-pre-wrap',
                            textAlign: 'left',
                            lineHeight: '15px',
                            padding: '10px 5px',
                            width: '100%',
                            border: `1px
                  dashed
                  ${EurestoColor('EurestoPrimary')}`,
                            borderTop: 0,
                            borderLeft: 0,
                            borderRight: 0,
                            backgroundColor: actionConfiguration && '#F3F3F3',
                            ...(this.state.preSelectedAction === action.id && {
                                backgroundColor: Color(EurestoColor('EurestoError')).lighten(0.35).string()
                            } || {})
                        }}>
                        {action.media_id &&
                            (action.media_type.indexOf('image/') !== -1 &&
                                <Grid container style={{ height: '100%', margin: 0, padding: 5 }} spacing={0}
                                    alignContent={'flex-start'}
                                    direction={'column'}
                                    justify={'flex-start'} alignItems={'stretch'}>
                                    <span>{action.media_libelle} :</span>
                                    <img width={'auto'} height={'auto'} src={action.media_lien} alt={action.media_libelle}
                                        style={{ maxWidth: 100, maxHeight: 100, cursor: 'pointer', padding: 5, }}
                                        onClick={this.onClickImage(action)} /></Grid> ||
                                <Grid container style={{ height: '100%', margin: 0, padding: 5 }} spacing={0}
                                    alignContent={'center'}
                                    justify={'flex-start'} alignItems={'center'}>
                                    <i className={'ei-module_documentation fa-2x'} />{action.media_libelle}
                                </Grid>) ||
                            <div
                                    dangerouslySetInnerHTML={{ __html: action.message }} />}
                        {action.lien &&
                            <Grid container
                                style={{ height: '100%', margin: 0, padding: 0 }}
                                spacing={0} alignContent={'flex-start'}
                                justify={'flex-start'}>
                                <Grid item style={{ height: '100%', margin: 0, padding: 0, position: 'relative' }}
                                    onClick={this.onClickImage(action, true)}>
                                    <img width={'auto'} height={'auto'} src={action.lien.split(',')[0]}
                                        alt={action.lien.split(',')[0]}
                                        style={{ maxWidth: 100, maxHeight: 100, cursor: 'pointer', padding: 5, }} />
                                    <Grid container justify={'center'} alignItems={'center'} alignContent={'center'}
                                        style={{
                                            position: 'absolute',
                                            bottom: 0,
                                            right: 0,
                                            width: 20,
                                            height: 20,
                                            borderRadius: '50%'
                                        }}
                                        className={'EurestoPrimary cursor-pointer EurestoText--text'}>{action.lien.split(',').length}</Grid>
                                </Grid>
                            </Grid>
                        }
                    </div>
                }
                {
                    action.type_action_id !== Constants.typeAction.CreationDossier && action.type_action_id !== Constants.typeAction.ModificationDossier && action.type_action_id !== Constants.typeAction.FermetureDossier &&
                    <Grid container alignContent={'flex-start'} spacing={0}
                        direction={'row'}
                        style={{
                            position: 'relative',
                            margin: 0, padding: '2.5px 0', backgroundColor: '#F3F3F3', textAlign: 'left',
                            border: `${actionConfiguration && 3 || action.importance >= 0 && 2 || 1}px
                  ${actionConfiguration && (configurationAction.action === 'duplicate' ? 'double' : 'ridge groove groove ridge') || 'solid'}
                  ${action.importance === 1 && EurestoColor('EurestoError') || action.importance === 0 && EurestoColor('EurestoPrimary') || EurestoColor('disabled', '')}`,
                            borderTop: 0,
                            borderLeft: 0,
                            borderRight: 0,
                        }}>
                        <Grid item
                            style={{
                                margin: 0, padding: 2.5, backgroundColor: 'white'
                            }}><img style={{ borderRadius: 5 }} width={25}
                                alt={Data.get(Constants.module.CONFIGURATION, Constants.donnee.utilisateur, { id: action.user_id }).slibelle}
                                src={
                                    Data.get(Constants.module.CONFIGURATION, Constants.donnee.utilisateur, { id: action.user_id }).media_lien || avatarPersonne
                                } /></Grid>
                        <Grid item xs
                            style={{
                                margin: 0, padding: 0
                            }}>
                            <Grid container alignContent={'flex-start'} spacing={0}
                                direction={'row'}
                                style={{
                                    margin: 0, padding: 0
                                }}>
                                <span style={{
                                    fontSize: '12px',
                                    margin: '0px 1px',
                                    lineHeight: 1.2
                                }}>{configAction &&
                                    <span>
                                        <i className={'ei-commun_valider EurestoPrimary--text'}
                                            style={{ borderRadius: 5, margin: '0px 2px', cursor: 'pointer' }}
                                            onClick={() => this.moveDuplicateAction(action.id, configAction)} />
                                        <i className={'ei-commun_fermer EurestoError--text'}
                                            style={{ borderRadius: 5, margin: '0px 2px', cursor: 'pointer' }}
                                            onClick={() => this.onClickConfigurationMessage(action.id)} />
                                    </span>
                                    ||
                                    this.state.messageConfiguration.findIndex(m => m.id === action.id) === -1 && this.parametreAction(action)}
                                    {action.type_action_id !== Constants.typeAction.Upload && <Tooltip disableTouchListener
                                        margin={'dense'} title={
                                            <Grid container spacing={0} style={{ padding: 5, fontSize: 15 }} direction={'column'}
                                                alignItems={'stretch'}>
                                                <div><label style={{
                                                    width: 27,
                                                    display: 'inline-block'
                                                }}>#id</label> : {action.id}</div>
                                                {action.source && <div><label style={{
                                                    width: 27,
                                                    display: 'inline-block'
                                                }}>{(action.type_action_id === Constants.typeAction.EmailRecu || action.type_action_id === Constants.typeAction.SmsRecu) && 'De' || 'À'}</label> : {action.source}
                                                </div>}
                                                {
                                                    ((action.type_action_id === Constants.typeAction.EmailEnvoi || action.type_action_id === Constants.typeAction.EmailRecu) && action.source_cc)
                                                    && (<div><label style={{
                                                        width: 27,
                                                        display: 'inline-block'
                                                    }}>CC</label> : {action.source_cc}</div>)
                                                }
                                                {
                                                    ((action.type_action_id === Constants.typeAction.EmailEnvoi || action.type_action_id === Constants.typeAction.EmailRecu) && action.source_cci)
                                                    && (<div><label style={{
                                                        width: 27,
                                                        display: 'inline-block'
                                                    }}>CCI</label> : {action.source_cci}</div>)
                                                }
                                                {
                                                    ((action.type_action_id === Constants.typeAction.EmailEnvoi || action.type_action_id === Constants.typeAction.EmailRecu) && action.config)
                                                    && (
                                                        <div><label style={{
                                                            width: 27,
                                                            display: 'inline-block'
                                                        }}>De</label> : {(typeof action.config === 'string' && JSON.parse(action.config).email_retour || action.config.email_retour)}
                                                        </div>)
                                                }
                                                {
                                                    action.date_differee
                                                    && (<span><br /><br />Date différée : {moment(action.date_differee).format('DD/MM/YY')}</span>)
                                                }
                                            </Grid>}>
                                        <i
                                            style={{
                                                fontSize: '12px', margin: '0px 1px', cursor: 'copy'
                                            }}
                                            onDoubleClick={this.copyLinkAction(action)}
                                            className={`ei-${action.type_action_id === Constants.typeAction.EmailRecu && 'commun_notification_email'
                                                || action.type_action_id === Constants.typeAction.EmailEnvoi && 'crm_campagne_email'
                                                || action.type_action_id === Constants.typeAction.SmsRecu && 'commun_notification_sms'
                                                || action.type_action_id === Constants.typeAction.SmsEnvoi && 'crm_campagne_sms'
                                                || action.type_action_id === Constants.typeAction.MessagePrive && 'crm_confidentiel'
                                                || 'commun_envoyer'
                                                }`} /></Tooltip>}
                                    {action.media_id && <a style={{ margin: '0px 1px' }} onClick={(e) => {
                                        e.stopPropagation()
                                    }} className={'fa fa-download'} href={action.media_lien} target={'_blank'}
                                        download='download' />}
                                    <i
                                        style={{
                                            fontSize: '12px',
                                            lineHeight: .9,
                                            margin: '0px 1px'
                                        }}>{Data.get(Constants.module.CONFIGURATION, Constants.donnee.utilisateur, { id: action.user_id }) !== undefined ? Data.get(Constants.module.CONFIGURATION, Constants.donnee.utilisateur, { id: action.user_id }).slibelle : ''},
                    {action.contact_relation_id && (
                                            <b>{`(${((this.state.relations || []).find(r => r.contact_id === action.contact_relation_id) || {}).contact_libelle})`}</b>) || ''}
                                        <i
                                            style={{
                                                fontSize: '12px', margin: '0px 1px 0px 2px'
                                            }}
                                            className={'fa fa-clock-o EurestoPrimary--text'} />{moment(action.date_creation).format('DD[/]MM[/]YY LT')} {action.date_creation !== action.date_modification &&
                                                <span><i
                                                    className={'ei-commun_modifier EurestoSecondary--text'} />{moment(action.date_modification).format('DD[/]MM[/]YY LT')}</span>}
                                    </i>
                                    {
                                        action.user_assign_id &&
                                        <Grid
                                            style={{
                                                lineHeight: .9,
                                                margin: '0px 1px'
                                            }}
                                            alignContent={'center'}
                                            direction={'row'}
                                            container>
                                            {action.user_assign_id === User.User.get().id && !configAction && this.state.messageConfiguration.findIndex(m => m.id === action.id) === -1 && this.flagAction(action)}
                                            {
                                                (action.flags || []).map(flag => <EmojiEuresto flag={flag} />)
                                            }
                                            <i
                                                style={{
                                                    fontSize: 12,
                                                    margin: '0px 1px',
                                                }}>{(action.flags || []).length > 0 && ', assigné' || 'Assigné '} à
                            {this.userAssignAction(action)}
                                                {
                                                    (action.date_echeance || action.date_traitement)
                                                    && <span>, prévu pour le {this.dateInterventionAction(action)}</span> || ``}
                                            </i>
                                        </Grid>
                                    }</span>
                            </Grid>
                        </Grid>

                        {action.type_action_id === Constants.typeAction.EmailEnvoi && <Grid item
                            style={{
                                position: 'absolute', right: 10,
                                margin: 0, padding: 0
                            }}>
                            <Tooltip disableTouchListener
                                margin={'dense'} title={
                                    <Grid container spacing={0} style={{ fontSize: 21, margin: 0, padding: "5px 2.5px" }} direction={'column'}
                                        alignItems={'stretch'}>
                                        Ouvert : {action.view}
                                    </Grid>}>
                                <Grid container spacing={0} style={{ fontSize: 15 }} direction={'column'}
                                    alignItems={'stretch'}>
                                    <i
                                        style={{
                                            fontSize: '25px', cursor: 'copy'
                                        }}
                                        onDoubleClick={this.copyLinkAction(action)}
                                        className={`ei-commun_notification_email ${action.view && action.view > 0 ? 'EurestoSecondary--text' : 'EurestoError--text'}`} />
                                </Grid>
                            </Tooltip>
                        </Grid>}
                    </Grid>}
            </Grid>
        )
    }

    handleCloseElUserAssignAction = (event, id) => {
        this.setState({
            anchorUserAssignActionEl: {
                ...this.state.anchorUserAssignActionEl || {},
                [id]: null
            }
        })
    }

    handleClickElUserAssignAction = (event, id) => {
        if (event.target.className.indexOf('anchorElementUserAssign') !== -1) {
            this.setState({
                anchorUserAssignActionEl: {
                    ...this.state.anchorUserAssignActionEl || {},
                    [id]: event.target
                }
            })
        }
    }

    repondreSMS = (action) => {
        console.log(action)
        this.setState({
            contact_relation_id: action.contact_relation_id,
            message: "",
            keySource: Utils.getRandomNumber(),
            type_action_id: Constants.typeAction.SmsEnvoi,
            source: action.source
        }, () => this.recherche(Constants.typeAction.SmsEnvoi, "type_action_id"))
    }

    userAssignAction = (action) => {
        const couldUpdateUserAssign = ((Data.get(Constants.module.CONFIGURATION, Constants.donnee.groupe_utilisateur, { id: action.user_assign_id }) || {})
            .utilisateurs || []).indexOf(User.User.get().id) !== -1
        return (
            <i className={'EurestoPrimary--text anchorElementUserAssign'}
                aria-owns={this.state.anchorUserAssignActionEl[action.id] ? 'action-menu-user-assign-' + action.id : null}
                aria-haspopup="true"
                onClick={(event) => {
                    if (couldUpdateUserAssign) {
                        this.handleClickElUserAssignAction(event, action.id)
                    }
                }}
                style={{
                    borderRadius: 5,
                    margin: '0px 2px',
                    cursor: couldUpdateUserAssign && 'pointer' || 'not-allowed'
                }}>
                <b
                    className={'anchorElementUserAssign ' + (action.etat !== 1 && 'EurestoError--text' || 'EurestoPrimary--text')}>
                    {(this.state.GroupeUtilisateurOptions.find(grp => grp.value === action.user_assign_id) || {}).label}
                </b>
                <Menu
                    style={{ paddingRight: 5, paddingLeft: 5 }}
                    id={'action-menu-user-assign-' + action.id}
                    keepMounted
                    anchorEl={this.state.anchorUserAssignActionEl[action.id] || null}
                    open={Boolean(this.state.anchorUserAssignActionEl[action.id]) || false}
                    onClose={(event) => this.handleCloseElUserAssignAction(event, action.id)}>
                    <MenuList>
                        <ListingModal
                            hideHeader
                            style={{
                                maxHeight: User.CalculHeight.getHeightWanted(300),
                            }}
                            inputStyle={{
                                marginBottom: 0
                            }}
                            title={EurestoI18n.t('crm:Assignée à')}
                            value={this.state.user_assign_id}
                            data={this.state.GroupeUtilisateurOptions.filter(r => !r.archive_id && r.groupe_id === action.user_assign_id)}
                            onClick={this.handleChangeUserAssign(action)}
                            libelle={action.user_assign_id && (this.state.GroupeUtilisateurOptions.find(g => g.value === action.user_assign_id) || {}).label} />
                    </MenuList>
                </Menu>
            </i>
        )
    }

    handleChangeDateTraitement = (action) => async (date) => {
        this.handleCloseElDateInterventionAction(null, action.id)
        if (!moment(date, 'YYYY-MM-DD').isSame(moment(action.date_echeance, 'YYYY-MM-DD'))) {
            await ApiRequest(project.api + 'sdd', {
                requete: 'action',
                action: 'update',
                id: action.id,
                date_traitement: date
            })
        }
    }

    handleChangeUserAssign = (action) => async (user_assign_id) => {
        this.handleCloseElUserAssignAction(null, action.id)
        if (action.user_assign_id !== user_assign_id) {
            await ApiRequest(project.api + 'sdd', {
                requete: 'action',
                action: 'update',
                id: action.id,
                user_assign_id: user_assign_id
            })
        }
    }

    onClickImage = (action, lien = false) => _ => {
        if (lien) {
            this.setState({
                viewFichier: true,
                medias_liens: action.lien.split(',').map(l => ({ src: l }))
            })
        } else {
            if (action.media_type.includes('image/') || action.media_type.includes('application/pdf')) {
                this.setState({
                    viewFichier: true,
                    media_lien: action.media_lien
                })
            } else {
                alert('Ce type de fichier ne peut être ouvert...')
            }
        }
    }

    handleFlagAction = (action) => (flag_id) => async _ => {
        const flags = this.state.actionFlagsSelected[action.id] || action.flags || []
        const pos = flags.indexOf(flag_id)
        if (pos === -1) {
            flags.push(flag_id)
        } else {
            flags.splice(pos, 1)
        }

        this.setState({
            actionFlagsSelected: {
                ...(this.actionFlagsSelected || {}),
                [action.id]: flags
            }
        })
    }

    dateInterventionAction = (action) => {
        return (
            <i className={'EurestoPrimary--text anchorElementDateIntervention'}
                aria-owns={this.state.anchorDateInterventionActionEl[action.id] ? 'action-menu-date-intervention-' + action.id : null}
                aria-haspopup="true"
                onClick={(event) => this.handleClickElDateInterventionAction(event, action.id)}
                style={{ borderRadius: 5, margin: '0px 2px', cursor: 'pointer' }}>
                <b
                    className={'anchorElementDateIntervention'}>{moment(action.date_traitement || action.date_echeance).format('ddd DD MMM YYYY')}</b>
                <Menu
                    style={{ paddingRight: 5, paddingLeft: 5 }}
                    id={'action-menu-date-intervention-' + action.id}
                    keepMounted
                    anchorEl={this.state.anchorDateInterventionActionEl[action.id] || null}
                    open={Boolean(this.state.anchorDateInterventionActionEl[action.id]) || false}
                    onClose={(event) => this.handleCloseElDateInterventionAction(event, action.id)}>
                    <MenuList>
                        <DatePicker
                            onChange={this.handleChangeDateTraitement(action)}
                            style={{ marginBottom: 0 }}
                            title={<span
                                className={'ei-reservation_calendrier'}>&nbsp;{EurestoI18n.t('commun:Date d\'intervention')}</span>}
                            id={'propsPicker-' + action.id}
                            value={action.date_traitement || action.date_echeance} />
                        {action.date_traitement && action.date_echeance &&
                            <i style={{ padding: '0px 5px 0px 2px' }}>Initialement prévu
                            pour
                            le <b>{moment(action.date_echeance).format('ddd DD MMM YYYY')}</b></i>}
                    </MenuList>
                </Menu>
            </i>
        )
    }

    flagAction = (action) => {
        return (
            <i className={'ei-commun_carre_plus EurestoPrimary--text anchorElementFlag'}
                aria-owns={this.state.anchorFlagActionEl[action.id] ? 'action-menu-flag-' + action.id : null}
                aria-haspopup="true"
                onClick={(event) => this.handleClickElFlagAction(event, action.id)}
                style={{ borderRadius: 5, margin: '0px 2px', cursor: 'pointer' }}>
                <Menu
                    style={{ paddingRight: 5, paddingLeft: 5 }}
                    id={'action-menu-flag-' + action.id}
                    anchorEl={this.state.anchorFlagActionEl[action.id] || null}
                    open={Boolean(this.state.anchorFlagActionEl[action.id]) || false}
                    onClose={(event) => this.handleCloseElFlagAction(event, action.id)}>
                    {
                        Data.list(Constants.module.SDD, Constants.donnee.flag).map(flag => {
                            const flags = this.state.actionFlagsSelected[action.id] || action.flags || []
                            return <MenuItem
                                style={{
                                    backgroundColor: flags.indexOf(flag.id) !== -1 && EurestoColor('EurestoPrimary'),
                                    color: flags.indexOf(flag.id) !== -1 && EurestoColor('EurestoText'),
                                }}
                                className={flags.indexOf(flag.id) !== -1 && 'EurestoPrimary EurestoText--text' || ''}
                                onClick={this.handleFlagAction(action)(flag.id)}>
                                <Emoji emoji={flag.icon} size={16} />&nbsp;{flag.libelle}</MenuItem>
                        }
                        )
                    }
                </Menu>
            </i>
        )
    }

    parametreAction = (action) => {
        return (
            <i className={'fa fa-cog EurestoPrimary--text anchorElement'}
                aria-owns={this.state.anchorActionEl[action.id] || false ? 'action-menu-' + action.id : null}
                aria-haspopup="true"
                onClick={(event) => this.handleClickElAction(event, action.id)}
                style={{ borderRadius: 5, margin: '0px 2px', cursor: 'pointer' }}>
                <Menu
                    style={{ paddingRight: 5, paddingLeft: 5 }}
                    id={'action-menu' + action.id}
                    anchorEl={this.state.anchorActionEl[action.id] || null}
                    open={Boolean(this.state.anchorActionEl[action.id]) || false}
                    onClose={(event) => this.handleCloseElAction(event, action.id)}>
                    {action.user_assign_id && action.etat !== 1 &&
                        <MenuItem
                            onClick={(event) => this.handleCloseElAction(event, action.id) || this.doneMessage(action)}><i
                                className={'ei-commun_modifier'} />&nbsp;Demande traitée</MenuItem>}
                    <MenuItem
                        onClick={(event) => this.handleCloseElAction(event, action.id) || this.onClickConfigurationMessage(action.id, 'duplicate')}><i
                            className={'ei-commun_dupliquer'} />&nbsp;Dupliquer</MenuItem>
                    <MenuItem
                        onClick={(event) => this.handleCloseElAction(event, action.id) || this.onClickConfigurationMessage(action.id, 'move')}><i
                            className={'ei-commun_deplacer'} />&nbsp;Déplacer</MenuItem>
                    {
                        action.type_action_id === Constants.typeAction.SmsRecu &&
                        <MenuItem
                            onClick={(event) => this.handleCloseElAction(event, action.id) || this.repondreSMS(action)}><i
                                className={'ei-crm_campagne_sms'} />&nbsp;Répondre</MenuItem>
                    }
                    {
                        (action.messagerie_type === "sms_unavailability" || action.user_id === User.User.get().id) &&
                        <MenuItem
                            onClick={(event) => this.handleCloseElAction(event, action.id) || this.deleteMessage(true, action)}><i
                                className={'ei-commun_supprimer EurestoError--text'} />&nbsp;Supprimer</MenuItem>
                    }
                    {
                        action.user_id === User.User.get().id && action.type_action_id !== Constants.typeAction.Upload
                        && action.type_action_id !== Constants.typeAction.EmailEnvoi
                        && action.type_action_id !== Constants.typeAction.SmsEnvoi
                        && <MenuItem
                            onClick={(event) => this.handleCloseElAction(event, action.id) || this.updateMessage(action)}>
                            <i className={'ei-commun_modifier EurestoSecondary--text'} />&nbsp;Modifier</MenuItem>
                    }
                    {action.user_assign_id === User.User.get().id && action.etat !== 1 && (!action.date_echeance && !action.date_traitement) &&
                        <MenuItem
                            onClick={(event) => this.handleCloseElAction(event, action.id) || this.defineDateTraitement(action.id)}><i
                                className={'ei-commun_modifier'} />&nbsp;Définir une date d'intervention</MenuItem>}
                </Menu>
            </i>
        )
    }

    defineDateTraitement = id => {
        const actions = this.state.actions
        const pos = actions.findIndex(act => act.id === id)
        if (pos !== -1) {
            actions[pos].date_traitement = moment().format('YYYY-MM-DD')
        }
        this.setState({
            actions: actions
        })
    }

    doneMessage = async message => {
        await ApiRequest(project.api + 'sdd', {
            requete: 'action',
            action: 'update',
            id: message.id,
            etat: 1,
            dossier_id: message.dossier_id
        })
    }

    updateMessage = async message => {
        this.setState({
            action_id_update: message.id,
            user_assign_id: message.user_assign_id,
            contact_relation_id: message.contact_relation_id,
            type_action_id: message.type_action_id,
            update_type_action_id: message.type_action_id,
            message: message.message,
            keyWysiwyg: Utils.getRandomNumber(),
            date_echeance: message.date_echeance,
            importance: message.importance,
        })
    }

    deleteMessage = (show = true, message) => {
        this.setState({
            showModalDelete: show,
            keyWysiwyg: Utils.getRandomNumber(),
            messageDeleteId: message ? message.id : null
        })
    }

    deleteMessageConfirm = async  _ => {
        await ApiRequest(project.api + 'sdd', {
            requete: 'action',
            action: 'delete',
            id: this.state.messageDeleteId
        })
        this.deleteMessage(false)
    }

    onClickConfigurationMessage = (id, action) => {
        const messageConfiguration = this.state.messageConfiguration
        const i = messageConfiguration.findIndex(m => m.id === id)
        if (i === -1) {
            messageConfiguration.push({
                id: id,
                message: this.state.actions.find(a => a.id === id),
                action: action
            })
        } else {
            messageConfiguration.splice(i, 1)
        }

        this.setState({
            messageConfiguration: messageConfiguration,
            anchorActionEl: {
                ...this.state.anchorActionEl || {},
                [id]: null
            }
        })
    }

    onChangeMessage = (val) => {
        this.setState({
            message: val
        })
    }

    moveDuplicateAction = async (id, action) => {
        let send
        const dossier_id = this.state.dossierId && typeof this.state.dossierId === 'number' && this.state.dossierId || undefined
        const classeur_id = this.state.dossierId && (typeof this.state.dossierId === 'string' && parseInt(this.state.dossierId.replace('default_', '')) || this.state.dossier.classeur_id)

        if (action === 'move') {
            send = {
                requete: 'action',
                action: 'update',
                dossier_id: dossier_id,
                classeur_id: classeur_id,
                contact_id: this.state.client_id,
                id: id
            }
        } else if (action === 'duplicate') {
            const act = (this.state.messageConfiguration.find(m => m.id === id) || {}).message
            send = {
                requete: 'action',
                action: 'add',
                message: act.message,
                contact_id: act.contact_id,
                dossier_id: dossier_id,
                classeur_id: classeur_id,
                type_action_id: act.type_action_id,
                contact_relation_id: act.contact_relation_id,
                user_assign_id: act.user_assign_id,
                action_id: id,
                media_id: act.media_id
            }
        }
        const result = await ApiRequest(project.api + 'sdd', send)
        if (action === 'move') this.onClickConfigurationMessage(id)
    }

    sendMessage = async (type_action_id, upload) => {
        let send
        const dossier_id = this.state.dossierId && typeof this.state.dossierId === 'number' && this.state.dossierId || undefined
        const classeur_id = this.state.dossierId && (typeof this.state.dossierId === 'string' && parseInt(this.state.dossierId.replace('default_', '')) || this.state.dossier.classeur_id)
        if (type_action_id === Constants.typeAction.Upload) {
            send = {
                requete: 'action',
                action: 'add',
                message: '',
                contact_id: this.state.client_id,
                dossier_id: dossier_id,
                classeur_id: classeur_id,
                type_action_id: Constants.typeAction.Upload,
                contact_relation_id: this.state.contact_relation_id,
                user_assign_id: this.state.user_assign_id,
                media_id: upload.id,
                action_id: this.state.reponse_to_action_id
            }
        } else {
            const message = this.state.message || ''
            if ((message.replaceAll('\\s', '') !== '' && message.replaceAll('\\s', '') !== '<p></p>') || (this.state.medias || []).length > 0) {
                send = {
                    requete: 'action',
                    action: this.state.action_id_update && 'update' || 'add',
                    id: this.state.action_id_update,
                    message: message,
                    contact_id: this.state.client_id,
                    dossier_id: dossier_id,
                    classeur_id: classeur_id,
                    type_action_id: this.state.type_action_id,
                    contact_relation_id: this.state.contact_relation_id,
                    user_assign_id: this.state.user_assign_id,
                    action_id: this.state.reponse_to_action_id,
                    date_echeance: this.state.date_echeance,
                    importance: this.state.importance,
                    source: this.state.source,
                    source_cc: this.state.source_cc,
                    source_cci: this.state.source_cci,
                    medias: this.state.medias || [],
                    libelle: this.state.libelle,
                    ...((this.state.portable_retour || this.state.email_retour) && {
                        config: {
                            portable_retour: this.state.portable_retour,
                            email_retour: this.state.email_retour,
                        }
                    } || {})
                }
            }
        }
        if (send) {
            const result = await ApiRequest(project.api + 'sdd', send, {
                showAlertError: true
            })
            if (result.code === 1) {
                this.setState({
                    medias: [],
                    action_id_update: undefined,
                    message: '',
                    contact_relation_id: undefined,
                    user_assign_id: undefined,
                    type_action_id: Constants.typeAction.Message,
                    reponse_to_action_id: undefined,
                    uploadFileAction: [],
                    keyUpload: type_action_id === Constants.typeAction.Upload && Utils.getRandomNumber() || this.state.keyUpload,
                    keyWysiwyg: type_action_id !== Constants.typeAction.Upload && Utils.getRandomNumber() || this.state.keyWysiwyg,
                    keySource: Utils.getRandomNumber(),
                    importance: undefined,
                    date_echeance: undefined,
                    source: undefined,
                    source_cc: undefined,
                    source_cci: undefined,
                    libelle: undefined,
                })
            }
        }
    }

    handleClickModalDossier = (open, action) => {
        let dossier = {}

        if (open === false && !action && this.state.dossierId && typeof this.state.dossierId === 'number') {
            const dossierSelect = EurestoClone(this.state.dossiers.find(d => parseInt(d.id) === parseInt(this.state.dossierId)) || {})
            if (dossierSelect) {
                dossier.classeur_id = dossierSelect.classeur_id
                dossier.id = dossierSelect.id
                dossier.libelle = dossierSelect.libelle
                dossier.type_categorie_id = dossierSelect.type_categorie_id
                dossier.confidentiel = dossierSelect.confidentiel
                dossier.participants = dossierSelect.participants || []
                dossier.dossier_id = dossierSelect.dossier_parent_id
                dossier.dossier_parent_libelle = dossierSelect.dossier_parent_libelle || ''
                dossier.type_dossier = dossierSelect.type_dossier
            }
        } else if (action === 'update') {
            dossier = this.state.dossier || {}
        }

        if (action === 'add') {
            dossier.classeur_id = this.state.dossierId && (typeof this.state.dossierId === 'string' && parseInt(this.state.dossierId.replace('default_', '')) || this.state.dossier.classeur_id)
        }

        if (open && dossier.classeur_id) {
            const classeurInfo = Data.get(Constants.module.SDD, Constants.donnee.classeur, {
                id: dossier.classeur_id,
                ...(this.state.client_id !== 1 && { visible: 1 } || {}),
            })
            if (classeurInfo && classeurInfo.classeur_id !== null) {
                dossier.sclasseur_id = dossier.classeur_id
                dossier.classeur_id = classeurInfo.classeur_id
            }
        }

        this.setState({
            dossier: dossier,
            showModalDossier: open,
            actionModalDossier: action,
            keyModalDossier: Utils.getRandomNumber()
        })
    }

    handleClickModalContact = (open) => {
        this.setState({
            showModalContact: open,
            keyModalDossier: Utils.getRandomNumber()
        })
    }

    handleClickModalRelation = (open) => {
        this.setState({
            showModalRelation: open,
            keyModalDossier: Utils.getRandomNumber()
        })
    }

    expendClasseur = (classeur_id, forceTrue = false) => {
        let classeurExpended = this.state.classeurExpended
        if (classeur_id) {
            classeurExpended = { [classeur_id]: true }

            const classeurInfo = Data.get(Constants.module.SDD, Constants.donnee.classeur, {
                id: classeur_id,
                ...(this.state.client_id !== 1 && { visible: 1 } || {}),
            })
            if (classeurInfo && classeurInfo.classeur_id !== null) {
                classeurExpended[classeurInfo.classeur_id] = true
            }
        }
        return classeurExpended
    }

    handleNewDossier = (data) => {
        let dossiers = [...this.state.dossiers]
        let dossierIdLast
        let classeurIdLast
        const notDeleteState = {}
        if (data.action === Constants.broadcastAction.add) {
            const pos = dossiers.findIndex(d => parseInt(d.id) === parseInt(data.results[0].id))
            if (pos === -1) {
                dossiers.push(data.results[0])
                dossiers.move(dossiers.length - 1, 0)
            }
        } else if (data.action === Constants.broadcastAction.update) {
            data.results.map(d => {
                const pos = dossiers.findIndex(ds => ds.id === d.id)
                if (pos !== -1) {
                    dossiers[pos] = d
                } else {
                    dossiers.push(d)
                    dossiers.move(dossiers.length - 1, 0)
                }
            })
        } else if (data.action === Constants.broadcastAction.delete) {
            const pos = dossiers.findIndex(d => d.dossier_id === data.id)
            if (pos !== -1) {
                dossiers.splice(pos, 1)
            }
        }
        if (data.action !== Constants.broadcastAction.delete) {
            notDeleteState.classeurExpended = this.expendClasseur(data.results[0].classeur_id, true)
        } else {
            if (dossiers.length > 0) {
                const dossier = dossiers.find(d => this.state.showOnlyOpenTicket ? d.status !== 0 : true)
                dossierIdLast = parseInt(dossier.dossier_id)
                classeurIdLast = parseInt(dossier.classeur_id)
                notDeleteState.classeurExpended = this.expendClasseur(classeurIdLast, true)
            }
        }
        this.setState({
            dossiers: dossiers,
            ...notDeleteState,
            dossierKey: Utils.getRandomNumber(),
        }, () => {
            data.action !== Constants.broadcastAction.delete ? this.selectDossier(data.results[0].classeur_id, data.results[0].id) : this.selectDossier(classeurIdLast, dossierIdLast)
        })
    }

    handleNewAction = (data) => {
        let actions = this.state.actions
        let actions_user = this.state.actions_user
        if (data.action === Constants.broadcastAction.add) {
            const pos = actions.findIndex(d => d.id === data.results.id)
            if (pos === -1) {
                actions.push(data.results)
                actions_user.push(data.results)
            }
        }
        if (data.action === Constants.broadcastAction.update) {
            const pos = actions.findIndex(d => d.id === data.results.id)
            if (pos !== -1) {
                actions[pos] = data.results
            } else {
                actions.push(data.results)
            }
            if (data.results.user_assign_id === User.User.get().id) {
                const posActsUser = actions_user.findIndex(d => d.id === data.results.id)
                if (posActsUser === -1 && data.results.etat === 0) {
                    actions_user.push(data.results)
                } else if (posActsUser !== -1 && data.results.etat === 1) {
                    actions_user.splice(posActsUser, 1)
                }
            }
        }
        if (data.action === Constants.broadcastAction.delete) {
            const pos = actions.findIndex(d => d.id === data.id)
            if (actions[pos].user_assign_id === User.User.get().id) {
                const posActsUser = actions_user.findIndex(d => d.id === data.id)
                actions_user.splice(posActsUser, 1)
            }
            if (pos !== -1) {
                actions.splice(pos, 1)
            }
        }
        this.autoScroll = data.action === Constants.broadcastAction.add
        this.setState({
            actions: actions,
            actions_user: actions_user
        })
    }

    scrollToBottom = () => {
        this.messagesEnd && this.messagesEnd.scrollIntoView({ behavior: 'smooth' })
    }

    modalDelete = () => {
        return this.state.showModalDelete && <Modal
            grid={{xs: 5}}
                open={this.state.showModalDelete}
                onClose={() => this.deleteMessage(false)}>
                <EurestoDiv
                    title={''}
                    buttonsLeft={[
                        {
                            title: EurestoI18n.t('commun:Non'),
                            icon: ' ei-commun_fermer',
                            cb: () => this.deleteMessage(false),
                            className: 'EurestoError EurestoText--text'
                        },
                        {
                            title: EurestoI18n.t('commun:Oui'),
                            icon: ' ei-commun_valider',
                            cb: this.deleteMessageConfirm,
                            className: 'EurestoSecondary EurestoText--text'
                        }
                    ]}>

                    <Grid container style={{ margin: 0, padding: 10, fontWeight: 'bold' }} spacing={0} justify={'center'}
                        alignItems={'center'}>
                    Confirmez-vous la suppression du message ?
                        </Grid>
                    </EurestoDiv>
            </Modal>
    }

    modalDossier = () => {
        return (
            this.state.showModalDossier &&
            <Modal
                grid={{ xs: 5 }}
                open={this.state.showModalDossier}
                onClose={() => this.handleClickModalDossier(false)}>
                <EurestoDiv
                    title={this.state.actionModalDossier === 'update' && `Modification: ${(this.state.dossiers.find(d => parseInt(d.id) === parseInt(this.state.dossierId)) || {}).libelle}` || 'Nouveau ticket'}
                    buttonsLeft={[
                        {
                            title: EurestoI18n.t('commun:Annuler'),
                            icon: ' ei-commun_fermer',
                            cb: () => this.handleClickModalDossier(false),
                            className: 'EurestoError EurestoText--text'
                        },
                        {
                            title: EurestoI18n.t('commun:Enregistrer'),
                            icon: ' ei-commun_valider',
                            cb: this.onSaveDossier,
                            className: 'EurestoSecondary EurestoText--text'
                        }
                    ]}>
                    <Grid container style={{ margin: 0, padding: 0 }} spacing={0} justify={'center'}
                        alignItems={'center'}>
                        <Grid item style={{ margin: 0, padding: 5 }} xs={12}>
                            <Grid container spacing={0} style={{ margin: 0, padding: 0 }}>
                                <Grid item style={{ margin: 0, padding: 5 }} xs={6}>
                                    <DataComponent
                                        title={EurestoI18n.t('Objet')}
                                        onChange={this.onChangeStateDossier}
                                        name="libelle"
                                        type={Constants.typeSaisie.InputTextBasic}
                                        data={this.state.dossier.libelle}
                                    />
                                </Grid>

                                <Grid item style={{ margin: 0, padding: 5 }} xs={6}>
                                    <DataComponent
                                        title={EurestoI18n.t('Participants')}
                                        onChange={this.onChangeStateDossier}
                                        type={Constants.typeSaisie.ComboMulti}
                                        search={{ archive_id: null, entite: 1 }}
                                        data={this.state.dossier.participants}
                                        name="participants"
                                        columnOptions={'slibelle'}
                                        object={Constants.donnee.utilisateur}
                                        module={Constants.module.CONFIGURATION} />
                                </Grid>
                                <Grid item style={{ margin: 0, padding: 5 }} xs={6}>
                                    <Input
                                        onClick={() => this.handleClickModalContact(true)}
                                        className="upText"
                                        title={'Client'}
                                        disabled={(this.state.dossier.classeur_id === 49 || this.state.dossier.classeur_id === 50)}
                                        type="text"
                                        key={this.state.libelle_client_contact + '-' + (this.state.dossier && this.state.dossier.contact_id || 'X')}
                                        value={this.state.libelle_client_contact || ''}
                                        InputProps={{
                                            startAdornment: (
                                                <i style={{ zIndex: 3 }} className={'ei-commun_rechercher'} />
                                            ),
                                        }}
                                    />
                                </Grid>
                                <Grid item style={{ margin: 0, padding: 5 }} xs={6}>
                                </Grid>
                                <Grid item style={{ margin: 0, padding: 5 }}
                                    xs={this.state.dossier.classeur_id && Data.list(Constants.module.SDD, Constants.donnee.classeur, {
                                        classeur_id: this.state.dossier.classeur_id,
                                        ...(this.state.client_id !== 1 && { visible: 1 } || {}),
                                    }).length > 0 && 6 || 12}>
                                    <DataComponent
                                        title={EurestoI18n.t('Classeur')}
                                        onChange={this.onChangeStateDossier}
                                        type={Constants.typeSaisie.ComboSimple}
                                        disabled={(this.state.dossier.classeur_id === 49 || this.state.dossier.classeur_id === 50)}
                                        data={this.state.dossier.classeur_id}
                                        name="classeur_id"
                                        object={Constants.donnee.classeur}
                                        module={Constants.module.SDD}
                                        search={{
                                            classeur_id: null,
                                            ...(this.state.client_id !== 1 && { visible: 1 } || {}),
                                        }} />
                                </Grid>
                                {this.state.dossier.classeur_id && Data.list(Constants.module.SDD, Constants.donnee.classeur, {
                                    classeur_id: this.state.dossier.classeur_id,
                                    ...(this.state.client_id !== 1 && { visible: 1 } || {}),
                                }).length > 0 &&
                                    <Grid item style={{ margin: 0, padding: 5 }} xs={6}>
                                        <DataComponent
                                            key={this.state.dossier.classeur_id}
                                            title={EurestoI18n.t('Dossier')}
                                            onChange={this.onChangeStateDossier}
                                            type={Constants.typeSaisie.ComboSimple} x
                                            data={this.state.dossier.sclasseur_id}
                                            name="sclasseur_id"
                                            object={Constants.donnee.classeur}
                                            module={Constants.module.SDD}
                                            search={{
                                                classeur_id: this.state.dossier.classeur_id,
                                                ...(this.state.client_id !== 1 && { visible: 1 } || {}),
                                            }} />
                                    </Grid>}


                                {
                                    Data.list(Constants.module.SDD, Constants.donnee.info_tiers, this.state.dossier.classeur_id && { classeurs: { or: [{ contains: [this.state.dossier.sclasseur_id || this.state.dossier.classeur_id] }, { isEmpty: true }] } || {} }).map((info, i) => (
                                        <Grid key={info.id + '-' + this.state.client_id} item
                                            style={{ margin: 0, padding: 5 }} xs={6}>
                                            <DataComponent
                                                title={info.libelle}
                                                onChange={(data, name) => {
                                                    const infoTiers = this.state.dossier.information_tiers || {}
                                                    infoTiers[name] = data
                                                    this.onChangeStateDossier(infoTiers, 'information_tiers')
                                                }}
                                                name={info.id}
                                                infoTiers={true}
                                                object={Constants.donnee.info_tiers_donnees}
                                                module={Constants.module.SDD}
                                                search={{ information_tiers_id: info.id }}
                                                data={this.state.dossier.information_tiers && this.state.dossier.information_tiers[info.id]}
                                                type={info.type_saisie_id}
                                            />
                                        </Grid>
                                    ))
                                }
                                {(this.state.dossier.classeur_id !== 49 && this.state.dossier.classeur_id !== 50) &&
                                    <Grid item style={{ margin: 0, padding: 5 }} xs={6}>
                                        <Autocomplete
                                            autoComplete={false}
                                            title={EurestoI18n.t('Type Ticket')}
                                            onChange={this.onChangeStateDossier}
                                            data={this.state.dossier.type_dossier}
                                            name="type_dossier"
                                            options={[{
                                                value: 50,
                                                label: EurestoI18n.t('sdd:Bug')
                                            }, {
                                                value: 49,
                                                label: EurestoI18n.t('sdd:Amélioration/Développement')
                                            }]} />
                                    </Grid>
                                }
                                {
                                    this.state.dossier.type_dossier &&
                                    <Grid item style={{ margin: 0, padding: 5 }} xs={6}>
                                        <Input
                                            onClick={() => this.handleClickModalCas(true)}
                                            key={this.state.dossier.dossier_id}
                                            title={this.state.dossier.type_dossier === 50 && EurestoI18n.t('Bugs') || EurestoI18n.t('Améliorations/Développements')}
                                            value={this.state.dossier.dossier_parent_libelle}
                                            InputProps={{
                                                startAdornment: (
                                                    <i style={{ zIndex: 3 }} className={'ei-commun_rechercher'} />
                                                ),
                                                endAdornment: (
                                                    this.state.dossier.dossier_id &&
                                                    <i onClick={(e) => {
                                                        e.preventDefault()
                                                        e.stopPropagation()
                                                        this.setState({
                                                            dossier: {
                                                                ...(this.state.dossier || {}),
                                                                dossier_parent_libelle: '',
                                                                dossier_id: undefined
                                                            }
                                                        })
                                                    }}
                                                        style={{ zIndex: 3, marginRight: 7.5 }}
                                                        className={'ei-commun_fermer EurestoError--text cursor-pointer'} />
                                                )
                                            }}
                                        />
                                    </Grid>
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                </EurestoDiv>
            </Modal>
        )
    }

    handleClickModalTicketCas = (open) => {
        this.setState({
            showModalTicketCas: open,
            keyModalTicketCas: Utils.getRandomNumber()
        })
    }

    onSelectTicketCasCas = (dossier) => {
        browserHistory.push({
            pathname: '/crm/' + dossier.contact_id,
            state: {
                dossier_id: dossier.dossier_id || undefined,
                classeur_id: dossier.classeur_id,
                UserTabSelected: 2,
                dossier_status: dossier.status
            }
        })
    }

    modalTicketCas = () =>
        <Modal key={this.state.keyModalTicketCas} open={this.state.showModalTicketCas}
            onClose={() => this.handleClickModalTicketCas(false)}
            grid={{ xs: 8 }}>
            <EurestoDiv
                title={this.state.dossier && this.state.dossier.libelle}
                buttonsLeft={[{
                    icon: ' ei-commun_fermer',
                    className: 'EurestoError EurestoText--text',
                    cb: () => this.handleClickModalTicketCas(false)
                }]}
                style={{
                    margin: 0,
                    padding: 0,
                    maxHeight: User.CalculHeight.getHeightWanted(70),
                    height: User.CalculHeight.getHeightWanted(70),
                    overflowY: 'auto'
                }}>
                {
                    this.state.dossiersCas && <EurestoTable
                        onClick={this.onSelectTicketCasCas}
                        datas={this.state.dossiersCas}
                        columns={[{
                            header: 'Id',
                            id: 'id',
                            show: false,
                        },
                        {
                            header: '',
                            minWidth: 30,
                            Cell: d => <Grid style={{ height: '100%' }} container alignItems={'center'}
                                justify={'flex-start'}>{d.flags.map(flag => <EmojiEuresto
                                    flag={flag} />)}
                            </Grid>,
                            type: 'string',
                            id: 'flags',
                            sortable: false
                        },
                        {
                            header: <span>{EurestoI18n.t('commun:Date')}</span>,
                            width: 100,
                            id: 'date_modification',
                            type: 'date',
                            Cell: (row) => <span style={{
                                color: row.importance === 1 && EurestoColor('EurestoError') || row.importance !== 0 && EurestoColor('disabled', '')
                            }}>{moment(row.date_modification).format('DD/MM/YY HH:mm')}</span>
                        },
                        {
                            header: <span style={{ float: 'left' }}>{EurestoI18n.t('commun:Nom')}</span>,
                            sortable: false,
                            type: 'string',
                            minWidth: 200,
                            Cell: (row) => {
                                return <span style={{ float: 'left' }}>
                                    <b className={row.status === 0 && 'EurestoError--text'}>{row.libelle || ''}</b>
                                </span>
                            }
                        },
                        {
                            header: <span>{EurestoI18n.t('commun:Message')}</span>,
                            sortable: false,
                            type: 'string',
                            Cell: d => <Tooltip disableTouchListener placement="bottom-start" title={
                                <div
                                    style={{
                                        fontSize: 15,
                                        padding: 5,
                                        paddingLeft: 10,
                                        paddingRight: 10,
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: '-moz-pre-wrap',
                                        overflowWrap: 'break-word',
                                        textAlign: 'left',
                                    }}
                                    dangerouslySetInnerHTML={{ __html: d.message.replace(/<p>/g, '<span>').replace(/<\/p>/g, '</span>') }} />
                            }>
                                <span style={{ float: 'left' }}>{h2p(d.message)}</span>
                            </Tooltip>,
                            id: 'message',
                        },
                        {
                            id: 'user_id',
                            header: <span>{EurestoI18n.t('commun:Par')}</span>,
                            width: 120,
                            type: 'string',
                            Cell: (row) => {
                                return <span>{Data.get(Constants.module.CONFIGURATION, Constants.donnee.utilisateur, { id: row.user_id }) && Data.get(Constants.module.CONFIGURATION, Constants.donnee.utilisateur, { id: row.user_id }).slibelle}</span>
                            }
                        },
                        {
                            id: 'user_assign_id',
                            type: 'string',
                            header: <span>{EurestoI18n.t('commun:Assigné à')}</span>,
                            width: 120,
                            Cell: (row) => {
                                return <span
                                    className={!row.etat && 'EurestoError--text'}>{row.user_assign_id !== null && row.user_assign_id !== undefined && (Data.get(Constants.module.CONFIGURATION, Constants.donnee.utilisateur, { id: row.user_assign_id }) && Data.get(Constants.module.CONFIGURATION, Constants.donnee.utilisateur, { id: row.user_assign_id }).slibelle || Data.get(Constants.module.CONFIGURATION, Constants.donnee.groupe_utilisateur, { id: row.user_assign_id }) && Data.get(Constants.module.CONFIGURATION, Constants.donnee.groupe_utilisateur, { id: row.user_assign_id }).libelle)}</span>
                            }
                        },

                        {
                            header: <span>{EurestoI18n.t('commun:Intervention')}</span>,
                            width: 120,
                            type: 'date',
                            id: 'date_intervention',
                            Cell: (row) => row.date_intervention &&
                                <span>{moment(row.date_intervention, 'YYYY-MM-DD').format('DD/MM/YY')}</span> || ''
                        },]}
                    />
                }
            </EurestoDiv>
        </Modal>

    handleClickModalCas = (open) => {
        this.setState({
            showModalCas: open,
            addModalCas: -1,
            keyModalCas: Utils.getRandomNumber()
        })
    }

    handleClickAddCas = _ => {
        this.setState({
            dossierCas: {},
            addModalCas: 1,
            keyModalCas: Utils.getRandomNumber()
        })
    }

    onSelectCas = (row) => {
        this.setState({
            dossier: {
                ...this.state.dossier,
                dossier_parent_libelle: row.libelle,
                dossier_id: row.dossier_id,
            }
        }, () => this.handleClickModalCas(false))
    }

    handleChangeDossierCas = (data, name) => {
        this.setState({
            dossierCas: {
                ...(this.state.dossierCas || {}),
                [name]: data
            }
        })
    }

    saveDossierCas = async () => {
        const dossierCas = await ApiRequest(project.api + 'sdd', {
            requete: 'dossier',
            action: 'add',
            libelle: this.state.dossierCas.libelle,
            participants: this.state.dossierCas.participants,
            classeur_id: this.state.dossier.type_dossier
        }, { showAlertError: false })

        const result = await ApiRequest(project.api + 'sdd', {
            requete: 'action',
            action: 'add',
            message: this.state.dossierCas.message,
            dossier_id: dossierCas.id,
            classeur_id: this.state.dossier.type_dossier
        })

        if (result && result.code === 1) {
            this.onSelectCas({
                libelle: this.state.dossierCas.libelle,
                dossier_id: dossierCas.id
            })
        }

    }

    modalCas = () =>
        <Modal key={this.state.keyModalCas} open={this.state.showModalCas}
            onClose={() => this.handleClickModalCas(false)}
            grid={{ xs: 8 }}>
            {this.state.addModalCas !== 1 && <DataGridCas
                route={{
                    title: this.state.dossier && this.state.dossier.type_dossier === 50 && 'Bug' || 'Développement',
                    searchName: this.state.dossier && this.state.dossier.type_dossier === 50 && 'bug_' || 'developpement_',
                    onClick: this.onSelectCas,
                    maxHeight: User.CalculHeight.getHeightWanted(70),
                    defaultSearch: {
                        '[[group_by]]': 'sdd_action.contact_id,sdd_action.classeur_id,sdd_action.dossier_id',
                        '?actif': 1,
                        '?tous': 1,
                        'type_action_id': [1, 2, 3],
                        'type_action_id_non': true,
                        'classeur_id': this.state.dossier && this.state.dossier.type_dossier
                    },
                    showSearch: true,
                    btns: {
                        cancel: {
                            title: EurestoI18n.t('commun:Annuler'),
                            icon: 'ei-commun_fermer',
                            className: 'EurestoError EurestoText--text',
                        },
                        add: {
                            title: 'Ajouter',
                            icon: 'ei-commun_ajouter',
                            className: 'EurestoPrimary EurestoText--text',
                        }
                    },
                    handleAction: {
                        add: this.handleClickAddCas,
                        cancel: () => this.handleClickModalCas(false)
                    },
                    isAllow: {
                        cancel: true,
                        add: true
                    }
                }} />
                ||
                <EurestoDiv
                    title={this.state.dossier && this.state.dossier.type_dossier === 50 && 'Nouveau Bug' || 'Nouvelle demande de Développement'}
                    buttonsLeft={[{
                        title: EurestoI18n.t('commun:Annuler'),
                        icon: ' ei-commun_fermer',
                        className: 'EurestoError EurestoText--text',
                        cb: () => this.handleClickModalCas(false)
                    }, {
                        title: 'Enregistrer',
                        icon: ' ei-commun_valider',
                        cb: this.saveDossierCas
                    }]}
                    style={{
                        margin: 0,
                        padding: 10,
                        maxHeight: User.CalculHeight.getHeightWanted(70),
                        height: User.CalculHeight.getHeightWanted(70),
                        overflowY: 'auto',
                        position: 'relative',
                    }}>
                    <Grid item style={{ margin: 0, padding: 5 }} xs={6}>
                        <DataComponent
                            title={EurestoI18n.t('Nom')}
                            onChange={this.handleChangeDossierCas}
                            name="libelle"
                            type={Constants.typeSaisie.InputTextBasic}
                            data={this.state.dossierCas.libelle}
                        />
                    </Grid>

                    <Grid item style={{ margin: 0, padding: 5 }} xs={6}>
                        <DataComponent
                            title={EurestoI18n.t('Participants')}
                            onChange={this.handleChangeDossierCas}
                            type={Constants.typeSaisie.ComboMulti}
                            search={{ archive_id: null }}
                            data={this.state.dossierCas.participants}
                            name="participants"
                            object={Constants.donnee.utilisateur}
                            module={Constants.module.CONFIGURATION} />
                    </Grid>
                    <Wysiwyg onChange={this.handleChangeDossierCas}
                        maxHeight={`calc(100% - 50px)`}
                        name='message'
                        value={this.state.dossierCas.message} />
                </EurestoDiv>
            }
        </Modal>

    onSelectContact = (row) => {
        this.setState({
            dossier: {
                ...(this.state.dossier || {}),
                contact_id: row.id
            },
            libelle_client_contact: row.libelle
        })
        this.handleClickModalContact(false)
    }

    modalContact = () =>
        <Modal open={this.state.showModalContact} onClose={() => this.handleClickModalContact(false)}
            grid={{ xs: 8 }}>
            <EurestoDiv
                buttonsRight={[{
                    icon: ' ei-commun_fermer',
                    className: 'EurestoError--text EurestoText',
                    cb: () => this.handleClickModalContact(false)
                }]}
                style={{
                    margin: 0,
                    padding: 10,
                    maxHeight: User.CalculHeight.getHeightWanted(70),
                    height: User.CalculHeight.getHeightWanted(70),
                    overflowY: 'auto'
                }}>
                {
                    <DataGrid onClick={this.onSelectContact} view={'list'} style={{
                        maxHeight: User.CalculHeight.getHeightWanted(70),
                    }} type="client" name={'sdd-'} showSearch={true} />
                }
            </EurestoDiv>
        </Modal>

    modalRelation = () => <Modal open={this.state.showModalRelation}
        onClose={() => this.handleClickModalRelation(false)}
        grid={{ xs: 8 }}>
        <EurestoDiv
            buttonsRight={[{
                icon: ' ei-commun_fermer',
                className: 'EurestoError--text EurestoText',
                cb: () => this.handleClickModalRelation(false)
            }]}
            style={{
                margin: 0,
                padding: 10,
                maxHeight: User.CalculHeight.getHeightWanted(70),
                height: User.CalculHeight.getHeightWanted(70),
                overflowY: 'auto'
            }}>
            {
                <Relation onCancel={() => this.handleClickModalRelation(false)} onChange={this.saveNewRelation}
                    action={'add'} />
            }
        </EurestoDiv>
    </Modal>

    saveNewRelation = (relations) => async _ => {
        if (relations && relations.length > 0) {
            const result = await ApiRequest(project.api + 'crm', {
                requete: 'client',
                action: 'update',
                id: this.state.client_id,
                relations_keep_old: true,
                relations: [{
                    contact_id: relations[0].contact_id,
                    relation_id: relations[0].relation_id,
                    commentaire: relations[0].commentaire || ''
                }]
            })

            if (result && result.code === 1) {
                const rls = this.state.relations
                rls.push(relations[0])
                this.setState({
                    relations: rls,
                    contact_relation_id: relations[0].contact_id
                }, () => this.handleClickModalRelation(false))
            }
        }

    }

    handleMedia = (file, base64) => {
        console.log(file, base64)
    }

    handleUpload = (result) => {
        this.sendMessage(Constants.typeAction.Upload, result)
    }

    onSaveDossier = async _ => {
        let jsonGet = {
            requete: 'dossier',
            action: this.state.actionModalDossier || 'add'
        }
        jsonGet = {
            ...jsonGet,
            ...this.state.dossier,
            classeur_id: this.state.dossier.sclasseur_id || this.state.dossier.classeur_id,
            contact_id: this.state.dossier.contact_id || this.state.client_id
        }
        const result = await ApiRequest(project.api + 'sdd', jsonGet)
        if (result && result.code === 1) {
            this.props.handleDossier && this.props.handleDossier(result.id, jsonGet) || this.handleClickModalDossier(false) && this.selectDossier(this.state.dossier.sclasseur_id || this.state.dossier.classeur_id, result.id)
        }
    }

    closeDossier = status => {
        ApiRequest(project.api + 'sdd', {
            requete: 'dossier',
            action: 'change_status',
            status: status,
            id: this.state.dossierId
        })
    }

    handleModalCloseAllUnfinishedAction = (view) => {
        this.setState({
            modalCloseAllUnfinishedAction: view,
            modalCloseAllUnfinishedActionKey: Utils.getRandomNumber()
        })
    }

    handleReopenCloseDossier = async (status) => {
        const actionNotFinished = status === 0 && this.state.actions.find(action => action.etat === 0)
        if (actionNotFinished) {
            this.handleModalCloseAllUnfinishedAction(true)
        } else {
            this.closeDossier(status)
        }
    }

    handleDeleteDossier = async (status) => {
        ApiRequest(project.api + 'sdd', {
            requete: 'dossier',
            action: 'delete',
            id: this.state.dossierId
        })
    }

    onChangeStateDossier = (data, name) => {
        let jsclasseur = {}
        if (name === 'classeur_id') {
            jsclasseur = { sclasseur_id: undefined }
        }

        this.setState({
            dossier: {
                ...this.state.dossier,
                [name]: data,
                ...jsclasseur,
            }
        })
    }
}



// WEBPACK FOOTER //
// ./app/App/Module/SDD/Component/GestionDossier/index.js